/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable extra-rules/no-commented-out-code */
/* eslint-disable complexity */
import React from 'react';
import { PropTypes } from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import {
  setPickupModal,
  openPickupModalWithValues,
  setIsSkuEditFlag,
  getBopisStoresActn,
} from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import BAG_PAGE_ACTIONS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import CHECKOUT_ACTIONS from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import {
  getItemsWithEDD,
  getOrderEddDates,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import { fromAvailableStoresClick } from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.actions';
import {
  getIsPickupModalOpen,
  getSelectedPickupOption,
  getIsBopisPickupSelected,
  getNearestAvailableStore,
  getIsPickUpSelected,
  getDefaultSuggestedStore,
  getIsBossEditModalOpen,
  getUpdateCartItemLoader,
  getStoresIDList,
} from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  validateSkuDetails,
  isBOSSProductOOS,
  isProductOOS,
} from '@tcp/core/src/components/common/organisms/ProductPickup/util';
import {
  isPlccUser,
  getUserLoggedInState,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  fireEnhancedEcomm,
  isClient,
  updateStoreDataLocalStorage,
  getSessionStorage,
  getDateObject,
  getAPIConfig,
} from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import { getLedgerSummaryData } from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import {
  setAddedToBagButton,
  addedTobagMsg,
  setOutfitCarouselAddedButton,
  clearAddToCartMultipleItemErrorState,
  setStickyFooter,
  setPDPLargeImageURL,
  addItemToCartBopis,
  AddToPickupError,
  selectSizeMsgShow,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';

import {
  closeQuickViewModal,
  saveQVDataForPDP,
  getDataOnNewFitsClick,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getMapSliceForColor,
  loadOutfitV3,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import {
  setTabSectionName,
  updateMultipackSelection,
  updateSelectedSizeStatus,
  setAlternateStyles,
  setIsDeptClicked,
  isStickyATBLoaded,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions';
import { getProducts } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import {
  addedToBagMsgSelector,
  loyaltyAbTestFlagSelector,
  getPDPlargeImageColorSelector,
  getAddedToPickupError,
  isOpenAddedToBag,
  getAdddToBagBtnLoader,
  getAddedToBagError,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';

import {
  getABTestAddToBagDrawer,
  getIsPhysicalMpackEnabled,
  getIsImageSwatchDisabled,
  getIsABLoaded,
  getIsDynamicBadgeEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
  getABTestSwapMpackPills,
  getCartsSessionStatus,
  getIsRadialInventoryEnabled,
  getIsPdpServiceEnabled,
  getABTestPdpService,
  getIsAccessoryEnabled,
  getIsStickyAtbHeader,
  getIsVMPBossEnabled,
  getMultiPackThreshold,
  getIsNewPJPPDPRedesignEnabled,
  getIsFBTShowEnabled,
  getIsShowShipToHomeEddEnabled,
  getIsCrossBrandMerchandisingEnabled,
  isShopThisStoreModeOn,
  getIsPDPInventoryCheckEnabled,
  getIsUserPersonalizationEnabled,
  getUserPersonalizationRefreshTime,
  getIsBopisEnabled,
  getFetchClosestStore,
  getSwitchToSfccForStoreInfo,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getBossMultipleStoreEnabled,
  getBopisMultipleStoreEnabled,
  getIsHardcodeSizeMapEnabled,
  getHardcodeSizeMapConfig,
  getisQvPdpInfluencerHandleAbTest,
  getIsPlccPriceOnPDP,
  getIsSingleOptionEnabled,
  getOutfitV3WidgetVDABTest,
  getOutfitV3WidgetMnMABTest,
  getOutfitV3Widget,
  getIsAlsoAvailablePillsDisabled,
  getIsShowPriceRange,
  getABTestIsShowPriceRange,
  getIsPickupPromotionPDPEnabled,
  getIsSuppressOOSFitsEnabled,
  getShowColorSwatchLabelOnApp,
  getIsHeaderScrollViewDisabled,
  getIsShowDeleteIconInBag,
  getIsSupressATBModalOnBag,
  getShowBopisTileBasedOnStoreSpecials,
  getIsRedesignGlobalHeaderEnabled,
  getSfccSocialProofingEnabled,
  getSfccSocialProofingThreshold,
  getStoreSearchTypesParam,
  allowOnlineProductPickup,
  getIsAppendUPCInPDPURLEnabled,
  getIsSocialProofOnATBButtonEnabled,
  getIsStickyAtbButtonOnQvEnabled,
  getIsSplittingExtendedSizesEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getUnbxdId,
  getIsBopisFilterOn,
} from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import {
  getSelectedMultipack,
  getBreadCrumbs,
  getSelectedSizeDisabled,
  getAccessoriesData,
  getMultiPackProductInfo,
  getAllNewMultiPackData,
  getIsTakeDownProduct,
  getAlternateStyles,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import {
  getFromPage,
  getProductInfo,
  getFavoritePage,
  getDeliveryMethodIndex,
  getProductInfoFromBag,
  getIsFromBirthdayModule,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getCurrentCurrency } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getAlternateBrandName,
  getIsBopisFilterOn as getIsBopisFilterOnSlp,
  getFirstTimeCaptureBanner,
  getFirstTimeCaptureShopMenu,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { setProductDataForReview } from '@tcp/core/src/components/features/browse/WriteReviewDetail/container/WriteReview.actions';
import PickupStoreModalDynamicStore from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickupStoreModalDynamicStore';
import productUtil from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import {
  setSelectedProductId,
  getSelectedOutfitFitProduct,
} from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.actions';
import { getSelectedFitProduct } from '@tcp/core/src/components/features/browse/BundleProduct/container/BundleProduct.actions.js';
import CONSTANT from './ProductAddToBag.constants';
import { isCanada, parseBoolean } from '../../../../../utils';
import ProductAddToBag from '../views/ProductAddToBag.view';
import {
  getStickyATCABTest,
  getMultipackProductQV,
  getAllNewMultiPackQV,
  getAllNewMultiPackPickup,
  getMultipackProductPickup,
} from './ProductAddToBag.selector';
import {
  getIsOutfitAddedCTAEnabled,
  getOutfitCarouselState,
  getShowAddedToBagCTA,
  getOutfitCarouselAddedCTA,
  getSelectedProductList,
} from '../../../../features/browse/OutfitDetails/container/OutfitDetails.selectors';
import {
  getPageName,
  getPageSection,
  getPageSubSection,
  getUserStoreId,
} from '../../../organisms/PickupStoreModal/molecules/PickupStoreSelectionForm/container/PickupStoreSelectionForm.selectors';
import {
  getAccessories,
  getSecondarySelectedAccessories,
  getSelectedAccessories,
  getTempSelectedSecondaryAccessories,
  getGrandParentId,
  getCurrentHighlightedIndex,
  getSecondaryAccessories,
  getGrandParentSize,
  getDeselectSize,
  getGrandParentScreen,
  getGrandParentColor,
  getGrandParentFit,
  getGrandParentQuantity,
  getParentCustomizationType,
} from '../../Accessories/container/Accessories.selectors';
import {
  autoIncrementAccessary,
  storeParentProductQty,
  removeSecondaryAccessory,
  clearAllSelectedAccessories,
  resetSecondaryAccessoryDetails,
  accessorySizeErrorAction,
  saveAccessoryGrandParentSizeAction,
  deselectSizeAction,
  saveAccessoryGrandParentColorAction,
  saveAccessoryGrandParentQuantityAction,
  saveAccessoryGrandParentFitAction,
} from '../../Accessories/container/Accessories.actions';
import BagPageSelectors from '../../../../features/CnC/BagPage/container/BagPage.selectors';
import { isNewVendorEnabled } from '../../../../../services/handler/handlerWrapper';
import { SLASH_C_ROUTE } from '../../../../../constants/plp.constants';
import {
  setDefaultStore,
  setUserNearStoreData,
} from '../../../../features/account/User/container/User.actions';
import { getUserSelection, setUserSelection } from '../../../../../utils/userPersonalization';
import { getIsShopAllDrawerOpen } from '../../../../features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.selectors';
import { openShopAllDrawer } from '../../../../features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import { OpenBirthdayRecommandationDrawer } from '../../../../features/account/BirthdayProductListing/container/BirthdayProductListing.actions';
import { PRODUCT_ADD_TO_BAG } from '../../../../../constants/reducer.constants';
import { styliticsProductTabListDataSuccess } from '../../../organisms/StyliticsProductTabList/container/StyliticsProductTabList.actions';
import { removeCartItem } from '../../../../features/CnC/CartItemTile/container/CartItemTile.actions';

const userStoreFromStorage = (userDefaultStore) => {
  let userStore = userDefaultStore;
  if (userStore) {
    const currentDate = getDateObject();
    if (!userStore?.favStoreTimeStamp && !userStore?.akamaiStoreTimeStamp) {
      userStore.favStoreTimeStamp = currentDate;
    }
    updateStoreDataLocalStorage(userStore);
  } else {
    userStore = JSON.parse(getLocalStorage('defaultStore')) || '';
  }
  return userStore;
};

/**
 * This class is a container of Product Add to bag view
 *
 * @class ProductAddToBagContainer
 * @extends {React.PureComponent}
 */
class ProductAddToBagContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const { currentProduct, selectedColorProductId, size, isSBP, sbpFit, formValues } = props;
    this.initialValuesForm = this.getInitialValues(
      currentProduct,
      selectedColorProductId,
      {},
      true
    );
    this.sbpInitialValues(size, isSBP, sbpFit);
    let selectedFit = this.initialValuesForm && this.initialValuesForm.Fit;
    if (!selectedFit) {
      selectedFit = formValues?.Fit ? { name: formValues.Fit } : null;
    }

    this.displayATBErrorMessage = this.displayATBErrorMessage.bind(this);
    this.state = {
      selectedColor: this.initialValuesForm && this.initialValuesForm.color,
      selectedFit,
      selectedSize: this.initialValuesForm && this.initialValuesForm.Size,
      selectedQuantity: this.initialValuesForm && this.initialValuesForm.Quantity,
      isErrorMessageDisplayed: false,
      isATBErrorMessageDisplayed: false,
      fitChanged: true,
      persistSelectedFit: '',
      isBopisSelected: false,
      isBossSelected: false,
      isSTHSelected: false,
      isVMPBossEligible: undefined,
      isAccessoryMessageDisplayed: false,
      keepAlive:
        this.initialColorFitsSizesMapEntry &&
        this.initialColorFitsSizesMapEntry.miscInfo &&
        this.initialColorFitsSizesMapEntry.miscInfo.keepAlive,
      updatedFilterSize: false,
      updatedFilterFit: false,
      pickupSelectedState: '',
    };
    this.quantityListHolder = [];
    this.fitListHolder = [];
    this.newFitListHolder = [];
    this.sizeListHolder = [];
    this.initialValuesFormHolder = {};
    this.selectedColorHolder = {};
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { size, isSBP, sbpFit, selectedSizeFromOutfitProduct } = nextProps;

    const { selectedSize, selectedFit } = prevState;
    const update = {};
    if (selectedSizeFromOutfitProduct && selectedSize?.name !== selectedSizeFromOutfitProduct) {
      update.selectedSize = { name: selectedSizeFromOutfitProduct };
    }

    if (isSBP && size && selectedSize?.name !== size) {
      update.selectedSize = { name: size };
      this.initialValuesForm.Size = { name: size };
    }

    if (isSBP && sbpFit && selectedFit?.name !== sbpFit) {
      update.selectedFit = { name: sbpFit };
      this.initialValuesForm.Fit = { name: sbpFit };
    }

    return Object.keys(update).length ? update : null;
  }

  updateColorInState = (updatedSelectedColor) => {
    this.setState({
      selectedColor: updatedSelectedColor,
    });
  };

  componentDidMount() {
    const { isPDP, isAppendUPCInPDPURLEnabled } = this.props;
    if (isPDP && isAppendUPCInPDPURLEnabled) {
      this.selectSizeAndFitBasedOnUPC();
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { isQuickView, formValues, initialFormValues } = nextProps;
    const { selectedColor } = nextState;
    const initalSelectedColor = this.getInitalValue(isQuickView, formValues, initialFormValues);
    const updatedSelectedColor = {
      name: !initalSelectedColor ? '' : initalSelectedColor,
    };
    const currentColor = updatedSelectedColor && updatedSelectedColor.name;
    if (currentColor && currentColor !== (selectedColor && selectedColor.name)) {
      this.updateColorInState(updatedSelectedColor);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isShowDisabledSize,
      isSizeSelected,
      currentProduct,
      selectedColorProductId,
      formValues,
      productInfoFromBag,
      errorOnHandleSubmit,
      isPDP,
    } = this.props;
    const generalProductId = currentProduct && currentProduct?.generalProductId;
    const {
      currentProduct: prevCurrentProduct,
      selectedColorProductId: prevSelectedColorProductId,
      productInfoFromBag: prevProductInfoFromBag,
      errorOnHandleSubmit: prevErrorOnHandleSubmit,
    } = prevProps;
    const { selectedSize } = this.state;
    if (
      !isShowDisabledSize &&
      prevProps.isShowDisabledSize !== isShowDisabledSize &&
      !isSizeSelected &&
      prevProps.isSizeSelected !== isSizeSelected
    ) {
      this.updateSelectedSize();
    }

    if (
      (currentProduct &&
        currentProduct?.generalProductId !== prevCurrentProduct?.generalProductId) ||
      selectedColorProductId !== prevSelectedColorProductId
    ) {
      // update selected color once map is received from api
      this.setState(
        this.getStateValuesFromProps(currentProduct, selectedColorProductId, this.props)
      );
    }

    if (productInfoFromBag && productInfoFromBag !== prevProductInfoFromBag) {
      const { Fit, Quantity, color, Size } =
        ProductAddToBagContainer.getInitialValuesFromBag(productInfoFromBag);
      this.setState({
        selectedColor: color,
        selectedFit: { name: Fit },
        selectedSize: Size,
        selectedQuantity: Quantity,
      });
    }

    if (errorOnHandleSubmit && prevErrorOnHandleSubmit !== errorOnHandleSubmit) {
      this.displayATBErrorMessage(true);
    }

    if (isClient()) {
      this.preSelectSizeAndFitFromFiltersWeb();
    }

    if (
      isPDP &&
      formValues &&
      this.isNonEmptyFormValuesCheck(formValues) &&
      selectedSize?.name === ''
    ) {
      this.onUpdateSize('', generalProductId);
    }
  }

  componentWillUnmount() {
    this.resetFormValues();
  }

  isNonEmptyFormValuesCheck = (formValues) => {
    if (!formValues?.size) return false;
    if (formValues && isPlainObject(formValues.size)) {
      return formValues?.size?.name !== '';
    }
    return formValues?.size !== '';
  };

  selectSizeAndFitBasedOnUPC = () => {
    let params;
    if (typeof window !== 'undefined') {
      params = new URLSearchParams(window.location.search);
    }
    const variantId = params?.get('variantid');

    if (variantId) {
      const {
        currentProduct,
        currentProduct: { colorFitsSizesMap } = {},
        onChangeSize,
      } = this.props;
      const { selectedFit, selectedColor, selectedQuantity } = this.state;
      const generalProductId = currentProduct && currentProduct?.generalProductId;
      const productColorFitsSizesMap = this.shouldSuppressOOSFitsWithoutChecks()
        ? this.getColorFitsSizesMapWithoutOOSFits()
        : colorFitsSizesMap;

      const currentColorEntry = productColorFitsSizesMap?.find(
        (colorEntry) => colorEntry?.color?.name === selectedColor?.name
      );

      const { fits, hasFits } = currentColorEntry || {};

      fits?.some((fit) => {
        const { fitName, sizes } = fit;
        const foundSize = sizes.find((size) => size.variantNo === variantId);
        let updatedFit = selectedFit;
        if (foundSize) {
          if (fitName && selectedFit?.name && selectedFit?.name !== fitName) {
            updatedFit = { name: fitName };
            this.fitChange(fitName);
          }

          const sizeList = hasFits
            ? this.getSizeOptions(currentColorEntry, updatedFit)
            : this.getSizeOptions(currentColorEntry);

          const enabledSize = sizeList.find(
            (size) => size.displayName === foundSize.sizeName && !size.disabled
          );

          if (enabledSize) {
            const { sizeName } = foundSize || {};
            this.onUpdateSize(sizeName, generalProductId);
            this.setState({
              selectedSize: {
                name: sizeName,
              },
            });
            if (onChangeSize) {
              onChangeSize(
                selectedColor && selectedColor.name,
                sizeName,
                selectedFit && selectedFit.name,
                selectedQuantity
              );
            }
          }
          return true;
        }
        return false;
      });
    }
  };

  preSelectSizeAndFitFromFiltersWeb = () => {
    const {
      isFromPLPPage,
      isFromSLPPage,
      isCustomFormPartWeb,
      filteredFit,
      onFitChange,
      initialFormValues,
      currentProduct,
      filteredFitFromPDP,
      productInfoQV,
    } = this.props;
    const { selectedSize, updatedFilterSize, updatedFilterFit } = this.state;
    const generalProductId = currentProduct && currentProduct.generalProductId;
    if (
      (isFromPLPPage || isFromSLPPage) &&
      initialFormValues.Size &&
      isCustomFormPartWeb &&
      !updatedFilterSize &&
      (initialFormValues.Size !== selectedSize?.name ||
        selectedSize?.name === '' ||
        selectedSize?.name?.name === '')
    ) {
      if (filteredFit) {
        onFitChange(filteredFit);
        this.setState({
          selectedFit: {
            name: filteredFit,
          },
        });
      }
      this.onUpdateSize(initialFormValues.Size, generalProductId);
      this.sizeChange(initialFormValues.Size, initialFormValues.Size);

      this.setState({ updatedFilterSize: true });
    } else if (
      this.isUpdateFitSize() &&
      filteredFitFromPDP &&
      filteredFitFromPDP?.Fit &&
      !updatedFilterFit
    ) {
      this.fitChange(filteredFitFromPDP?.Fit);
      this.setState({
        updatedFilterFit: true,
      });
      const timer = setTimeout(() => {
        this.onUpdateSize(initialFormValues.Size, generalProductId);
        this.sizeChange(initialFormValues.Size, initialFormValues.Size);
        clearTimeout(timer);
      }, 0);
      this.setState({ updatedFilterSize: true });
    } else if (
      productInfoQV &&
      filteredFitFromPDP &&
      filteredFitFromPDP?.Size &&
      initialFormValues?.Size &&
      (initialFormValues.Size !== selectedSize?.name ||
        selectedSize?.name === '' ||
        selectedSize?.name?.name === '')
    ) {
      this.sizeChange(initialFormValues.Size, initialFormValues.Size);
    }
  };

  isValidFormValues = (initialFormValues) => {
    return initialFormValues && initialFormValues.Size && initialFormValues.Size !== '';
  };

  isValidSelectedSizeValues = (selectedSize) => {
    return selectedSize && (selectedSize.name || selectedSize.name.name);
  };

  isUpdateFitSize = () => {
    const { initialFormValues, isFromPLPPage, isFromSLPPage, isCustomFormPartWeb } = this.props;
    const { selectedSize } = this.state;
    return (
      !(isFromPLPPage || isFromSLPPage) &&
      !isCustomFormPartWeb &&
      this.isValidFormValues(initialFormValues) &&
      !this.isValidSelectedSizeValues(selectedSize)
    );
  };

  setSelectedFilterSize = () => {
    const { customFormFilterSize, filteredFit, currentProduct } = this.props;
    const generalProductId = currentProduct && currentProduct.generalProductId;
    if (customFormFilterSize) {
      if (filteredFit) {
        this.fitChange(filteredFit);
      }
      this.setState({ selectedSize: { name: customFormFilterSize } });
      if (this.initialValuesForm) this.initialValuesForm.Size = { name: customFormFilterSize };
      const timer = setTimeout(() => {
        this.onUpdateSize(customFormFilterSize, generalProductId);
        clearTimeout(timer);
      }, 0);
      this.setState({ updatedFilterSize: true });
    }
  };

  setSelectedSize = (formValues, selectedSize, isPickupModalOpen) => {
    if (
      formValues &&
      formValues.size &&
      selectedSize?.name !== '' &&
      formValues?.size !== '' &&
      selectedSize?.name !== formValues?.size &&
      !isPickupModalOpen
    ) {
      this.setState({
        selectedSize: {
          name: formValues.size,
        },
      });
    }
  };

  setSelectedFit = (formValues, selectedFit, isPickupModalOpen) => {
    if (
      formValues &&
      formValues.fit &&
      selectedFit?.name !== '' &&
      formValues?.fit !== '' &&
      selectedFit?.name !== formValues?.fit &&
      !isPickupModalOpen
    ) {
      this.setState({
        selectedFit: {
          name: formValues.fit,
        },
      });
    }
  };

  setSelectedDeliveryType = (prevProps, deliveryType, updatePickupSelectedAtProductDetail) => {
    if (prevProps.deliveryType !== deliveryType) {
      if (deliveryType === 'noRushPickup') {
        this.setState({ isBossSelected: true, isBopisSelected: false }, () => {
          return updatePickupSelectedAtProductDetail(false);
        });
      } else if (deliveryType === 'pickItUp') {
        this.setState({ isBossSelected: false, isBopisSelected: true }, () => {
          return updatePickupSelectedAtProductDetail(true);
        });
      } else {
        this.setState({ isBossSelected: false, isBopisSelected: false }, () => {
          updatePickupSelectedAtProductDetail(false);
        });
      }
    }
  };

  getStateValuesFromProps = (currentProduct, selectedColorProductId, nextProps) => {
    this.initialValuesForm = this.getInitialValues(
      currentProduct,
      selectedColorProductId,
      nextProps
    );
    return {
      selectedColor: this.initialValuesForm && this.initialValuesForm.color,
      selectedFit: this.initialValuesForm && this.initialValuesForm.Fit,
      selectedSize: this.initialValuesForm && this.initialValuesForm.Size,
      selectedQuantity: this.initialValuesForm && this.initialValuesForm.Quantity,
      persistSelectedFit: this.initialValuesForm && this.initialValuesForm.Fit,
    };
  };

  sbpInitialValues = (size, isSBP, sbpFit) => {
    if (isSBP && size) {
      this.initialValuesForm.Size = { name: size };
    }
    if (isSBP && sbpFit) {
      this.initialValuesForm.Fit = { name: sbpFit };
    }
  };

  // Naming for form values are different for ECOM and PICKUP items edit from cart.
  static getInitialValuesFromBag = (productInfoFromBag) => {
    const {
      Fit,
      Quantity,
      Size,
      color,
      selectedFit,
      selectedQty,
      selectedSize,
      selectedColor,
      Department = '',
      DepartmentSwatch = '',
    } = productInfoFromBag || {};
    const availableFit = Fit || selectedFit;
    return {
      Quantity: Quantity || selectedQty,
      Fit: availableFit
        ? {
            name: availableFit,
          }
        : null,
      Size: {
        name: Size || selectedSize,
      },
      color: {
        name: color || selectedColor,
      },
      Department,
      DepartmentSwatch,
    };
  };

  /**
   * @function getDefaultColor
   * @returns default color at 0 index in color array.
   *
   * @memberof ProductAddToBagContainer
   */
  getInitialValues = (currentProduct, selectedColorProductId, nextProps, isInitialCalc) => {
    const { colorFitsSizesMap } = currentProduct;
    return (
      colorFitsSizesMap &&
      this.defaultSizesSet(currentProduct, selectedColorProductId, nextProps, isInitialCalc)
    );
  };

  defaultSizesSet = (currentProduct, selectedColorProductId, nextProps, isInitialCalc) => {
    if (currentProduct) {
      return this.getInitialAddToBagFormValues(
        currentProduct,
        selectedColorProductId,
        nextProps,
        isInitialCalc
      );
    }

    return null;
  };

  getMapSliceForColorProductId = (colorFitsSizesMap, colorProductId, selectedColorProductId) => {
    const colorIdToMatch = selectedColorProductId || colorProductId;
    const selectedProduct =
      colorFitsSizesMap &&
      colorFitsSizesMap.find(
        (entry) =>
          entry.colorProductId === colorIdToMatch || entry.colorDisplayId === colorIdToMatch
      );
    return selectedProduct || (colorFitsSizesMap.length > 0 ? colorFitsSizesMap[0] : null);
  };

  getDefaultFitForColorSlice = (colorFitsSizesMapEntry, ignoreQtyCheck = false) => {
    const { sbpFit } = this.props;
    try {
      if (sbpFit) return { fitName: sbpFit.toLowerCase() };
    } catch (error) {
      logger.error(error);
    }
    return (
      colorFitsSizesMapEntry.fits.find(
        (fit) => !ignoreQtyCheck && fit.isDefault && fit.maxAvailable > 0
      ) ||
      colorFitsSizesMapEntry.fits.find((fit) => !ignoreQtyCheck && fit.maxAvailable > 0) ||
      colorFitsSizesMapEntry.fits[0]
    );
  };

  // eslint-disable-next-line complexity
  getDefaultSizeForProduct = (colorFitsSizesMap, initialFormValues) => {
    const { sbpSize } = this.props;

    if (sbpSize) return sbpSize;

    const firstSizeName = colorFitsSizesMap[0]
      ? colorFitsSizesMap[0].fits?.[0].sizes[0].sizeName
      : '';

    // eslint-disable-next-line no-restricted-syntax
    for (const colorEnrtry of colorFitsSizesMap) {
      if (
        colorEnrtry.fits?.length > 1 ||
        colorEnrtry.fits?.[0]?.sizes.length > 1 ||
        colorEnrtry.fits?.[0]?.sizes[0].sizeName !== firstSizeName
      ) {
        return (initialFormValues && initialFormValues.Size) || '';
      }
    }

    return firstSizeName;
  };

  getColor = (colorFitsSizesMapEntry) => {
    return (
      colorFitsSizesMapEntry && colorFitsSizesMapEntry.color && colorFitsSizesMapEntry.color.name
    );
  };

  initialAddToBagFormValuesSBP = (
    colorFitsSizesMapEntry,
    sbpFormValues,
    initialFormValues,
    currentProduct,
    giftCardDefaultSize
  ) => {
    return {
      color: {
        name: this.getColor(colorFitsSizesMapEntry),
      },
      Fit:
        colorFitsSizesMapEntry && colorFitsSizesMapEntry.hasFits
          ? {
              name: !initialFormValues
                ? this.getDefaultFitForColorSlice(colorFitsSizesMapEntry).fitName
                : initialFormValues.Fit,
            }
          : null,
      Size: {
        name: currentProduct.isGiftCard
          ? giftCardDefaultSize // on gift card we need something selected, otherwise no price would show up
          : this.getDefaultSizeForProduct(currentProduct.colorFitsSizesMap, initialFormValues),
      },
      Quantity: !sbpFormValues ? 1 : sbpFormValues.quantity,
    };
  };

  getGiftCardDefaultSize = (initialFormValues, currentProduct) => {
    return initialFormValues && initialFormValues.Size
      ? initialFormValues.Size
      : currentProduct.colorFitsSizesMap &&
          currentProduct.colorFitsSizesMap[0] &&
          currentProduct.colorFitsSizesMap[0].fits &&
          currentProduct.colorFitsSizesMap[0].fits[0].sizes[0].sizeName;
  };

  getColorFitsSizesMapEntry = (currentProduct, selectedColorProductId) => {
    return currentProduct
      ? this.getMapSliceForColorProductId(
          currentProduct.colorFitsSizesMap,
          currentProduct.generalProductId,
          selectedColorProductId
        )
      : {};
  };

  getFitValues = (initialFormValues, colorFitsSizesMapEntry, userSelection) => {
    const { formValues, isPDPInventoryCheckEnabled, isSplittingExtendedSizesEnabled } = this.props;

    if (isPDPInventoryCheckEnabled && formValues && formValues.fit) {
      return { name: typeof formValues.fit === 'object' ? formValues.fit.name : formValues.fit };
    }
    if (!initialFormValues) {
      return {
        name: this.getDefaultFitForColorSlice(colorFitsSizesMapEntry).fitName,
      };
    }
    if (initialFormValues?.Fit && !isSplittingExtendedSizesEnabled) {
      if (userSelection && userSelection.fit) {
        return { name: userSelection.fit };
      }
      return { name: initialFormValues.Fit };
    }

    const val = this.getDefaultFitForColorSlice(colorFitsSizesMapEntry).fitName;
    if ((!val || val === 'regular') && userSelection) {
      return { name: userSelection.fit };
    }
    if (val) return { name: val };
    return null;
  };

  getDepartment = (initialFormValues = {}, defaultDepartment) => {
    return initialFormValues.Department || defaultDepartment?.split('_')[0];
  };

  getDepartmentSwatch = (initialFormValues = {}, defaultDepartment) => {
    return initialFormValues.DepartmentSwatch || defaultDepartment;
  };

  // eslint-disable-next-line complexity
  getInitialAddToBagFormValues = (
    currentProduct,
    selectedColorProductId,
    nextProps,
    isInitialCalc
  ) => {
    const colorFitsSizesMapEntry = this.getColorFitsSizesMapEntry(
      currentProduct,
      selectedColorProductId
    );
    this.initialColorFitsSizesMapEntry = colorFitsSizesMapEntry;
    let { initialFormValues } = nextProps && nextProps.renderReceiveProps ? nextProps : this.props;
    const {
      fromBagPage,
      isSBPEnabled,
      sbpFormValues,
      fromPage,
      isOutfitPage,
      isMultiItemQVModal,
      productInfoFromBag,
      filteredFitFromPDP,
      alternateStyles,
    } = this.props;

    const { genderAgeGroup } = currentProduct || {};
    let defaultDepartment = '';
    if (alternateStyles) {
      const alternateStylesKeys = Object.keys(alternateStyles);
      const tmpAry = alternateStylesKeys.map((str) => str.split('_')?.[0]?.toLowerCase());
      const index = tmpAry.indexOf(genderAgeGroup?.toLowerCase());

      defaultDepartment = index !== -1 ? alternateStylesKeys[index] : alternateStylesKeys[0];
    }

    if (
      productInfoFromBag &&
      ((fromBagPage && isInitialCalc) || fromPage === 'fromPDPAccessories')
    ) {
      const { color, Fit, Quantity, Size, Department, DepartmentSwatch } =
        ProductAddToBagContainer.getInitialValuesFromBag(productInfoFromBag);
      initialFormValues = {
        color: color?.name,
        Size: Size?.name,
        Fit: Fit?.name,
        Quantity,
        Department,
        DepartmentSwatch,
      };
    }

    const giftCardDefaultSize = this.getGiftCardDefaultSize(initialFormValues, currentProduct);

    if (isSBPEnabled && sbpFormValues) {
      this.initialAddToBagFormValuesSBP(
        colorFitsSizesMapEntry,
        sbpFormValues,
        initialFormValues,
        currentProduct,
        giftCardDefaultSize
      );
    }
    // eslint-disable-next-line camelcase
    const { categoryPathMap, categoryPath3_catMap } = currentProduct;
    // eslint-disable-next-line camelcase
    const categoryMap = categoryPathMap || categoryPath3_catMap;
    const userSelection =
      !isOutfitPage && !isMultiItemQVModal ? getUserSelection(categoryMap) : null;
    const initialAddToBagFormValuesTemp = {
      color: {
        name: this.getColor(colorFitsSizesMapEntry),
      },
      Fit:
        colorFitsSizesMapEntry && colorFitsSizesMapEntry.hasFits
          ? (filteredFitFromPDP && filteredFitFromPDP.Fit && { name: filteredFitFromPDP.Fit }) ||
            this.getFitValues(initialFormValues, colorFitsSizesMapEntry, userSelection)
          : null,
      Size: {
        name: currentProduct.isGiftCard
          ? giftCardDefaultSize // on gift card we need something selected, otherwise no price would show up
          : this.getDefaultSizeForProduct(currentProduct.colorFitsSizesMap, initialFormValues),
      },
      Quantity:
        filteredFitFromPDP && filteredFitFromPDP.Quantity
          ? filteredFitFromPDP?.Quantity
          : initialFormValues?.Quantity || 1,
      DepartmentSwatch: this.getDepartmentSwatch(initialFormValues, defaultDepartment),
      Department: this.getDepartment(initialFormValues, defaultDepartment),
    };
    if (userSelection) {
      const sizeVal = initialAddToBagFormValuesTemp.Size?.name;
      if (sizeVal === '' && userSelection.size) {
        initialAddToBagFormValuesTemp.Size.name = userSelection.size;
      }
    }

    if (!isEqual(initialAddToBagFormValuesTemp, this.initialValuesFormHolder)) {
      this.initialValuesFormHolder = { ...initialAddToBagFormValuesTemp };
    }
    return this.initialValuesFormHolder;
  };

  triggerGAanalytics = () => {
    const obj = {
      event: 'event101',
      eventName: 'styleWithInteraction',
    };
    fireEnhancedEcomm({
      isCustomEvent: true,
      event: obj,
    });
  };

  updateSelectedSize = () => {
    const {
      currentProduct: { colorFitsSizesMap },
      initialFormValues,
    } = this.props;
    const { selectedSize } = this.state;
    const sizeList = this.getSizeList(colorFitsSizesMap);
    if (!isClient() && sizeList.length === 1) {
      this.setState({
        selectedSize: {
          name: sizeList[0].displayName,
        },
      });
    }
    if (isClient() && sizeList.length === 1 && !selectedSize?.name && !initialFormValues?.Size) {
      this.sizeChange(sizeList[0].displayName, sizeList[0].displayName);
    }
  };

  getFormNameProductAddToBag = () => {
    const {
      currentProduct,
      isQuickView,
      isFBTEnabled,
      isMultiItemQVModal,
      customFormName,
      multiQVItemIndex,
    } = this.props;
    if (currentProduct) {
      const formName = customFormName || PRODUCT_ADD_TO_BAG;

      let tmpFormName = '';
      if (isMultiItemQVModal) {
        tmpFormName = `${formName}-QV-${currentProduct.generalProductId}_${multiQVItemIndex}`;
      } else if (!isMultiItemQVModal && isQuickView && isFBTEnabled) {
        tmpFormName = `${formName}-QV-${currentProduct.generalProductId}`;
      } else {
        tmpFormName = `${formName}-${currentProduct.generalProductId}`;
      }
      return tmpFormName;
    }
    return '';
  };

  getFilterSizeList = (fitVal) => {
    const { selectedColor } = this.state;
    const {
      formValues,
      currentProduct,
      colorFitsSizesMap: favColorFitsSizesMap,
      isQuickView,
      initialFormValues,
      isMultiItemQVModal,
    } = this.props;
    const initalSelectedColor = this.getInitalValue(
      isQuickView,
      formValues,
      initialFormValues,
      selectedColor,
      isMultiItemQVModal
    );
    const updatedSelectedColor = { name: initalSelectedColor || '' };
    const productColorFitsSizesMap = currentProduct?.colorFitsSizesMap || favColorFitsSizesMap;
    const sizeList = this.getUpdatedSizeList(productColorFitsSizesMap, updatedSelectedColor, {
      name: fitVal,
    });
    const size = initialFormValues?.Size || this.initialValuesForm?.Size;
    if (isClient()) {
      return sizeList.filter(
        (data) => data?.displayName === (formValues?.size ?? size) && !data.disabled
      );
    }
    return sizeList.filter((data) => data?.displayName === formValues?.size && !data.disabled);
  };

  resetData = (resetProductDetailsDynamicData) => {
    return isClient() && resetProductDetailsDynamicData();
  };

  onNewFitClick = ({ colorFitsSizesMap, selectedColor, selectedFit }) => {
    const {
      getDetails,
      alternateBrand,
      currentProduct,
      isQuickView,
      isPDP,
      fromPage,
      onQuickViewOpenClick,
      onPickUpOpenClick,
      isPickup,
      fromBagPage,
      productInfoFromBag,
      isBundleProduct,
      bundleItemIndex,
      getSelectedFitProductActn,
      isOutfitPage,
      getSelectedOutfitFitProductActn,
      outfitItemIndex,
      isMultiItemQVModal,
      multiQVItemIndex,
      getDataOnNewFitsClickActn,
    } = this.props;
    const currentColorFit = colorFitsSizesMap?.filter(
      (item) => item?.color?.name === selectedColor?.name
    );

    const prodId = currentColorFit[0]?.newFitProductMap[selectedFit?.toLowerCase()];

    const { generalProductId } = currentProduct || {};
    const apiConfig = getAPIConfig();

    if (prodId) {
      this.setState({
        selectedFit: {
          name: selectedFit?.toLowerCase(),
        },
      });
      if (isPDP) {
        getDetails({
          productColorId: prodId,
          generalProductId,
          otherBrand: alternateBrand,
          apiConfig,
          newFitsEnabled: true,
          escapeEmptyProduct: true,
        });
      } else if (isPickup) {
        onPickUpOpenClick({
          productColorId: prodId,
          colorProductId: prodId,
          generalProductId,
          getDetailonClick: true,
          isProductPickup: true,
          otherBrand: alternateBrand,
          fromPills: true,
          newFitsEnabled: true,
          orderInfo: productInfoFromBag,
        });
      } else if (isQuickView && !isMultiItemQVModal) {
        onQuickViewOpenClick({
          colorProductId: prodId,
          generalProductId,
          escapeEmptyProduct: true,
          getDetailonClick: true,
          fromPage,
          otherBrand: alternateBrand,
          fromBagPage,
          orderInfo: productInfoFromBag,
          newFitsEnabled: true,
        });
      } else if (isBundleProduct) {
        getSelectedFitProductActn({
          prodId,
          bundleItemIndex,
          generalProductId,
        });
      } else if (isOutfitPage) {
        getSelectedOutfitFitProductActn({
          vendorColorProductIdsList: prodId,
          isOutfitPage,
          outfitItemIndex,
        });
      } else if (isMultiItemQVModal) {
        getDataOnNewFitsClickActn({
          multiQVItemIndex,
          colorProductId: prodId,
          generalProductId,
          fromPage,
        });
      }
    }
  };

  checkForNewFits = ({ colorFitsSizesMap, selectedColor, isSplittingExtendedSizesEnabled }) => {
    const currentColorFit = colorFitsSizesMap?.filter(
      (item) => item?.color?.name === selectedColor?.name
    );
    return (
      currentColorFit?.length > 0 &&
      isSplittingExtendedSizesEnabled &&
      currentColorFit[0]?.hasNewFitAttribute
    );
  };

  getFitProductId = ({ colorFitsSizesMap, selectedColor, selectedFit }) => {
    const currentColorFit = colorFitsSizesMap?.filter(
      (item) => item?.color?.name === selectedColor?.name
    );
    return currentColorFit[0]?.newFitProductMap[selectedFit?.toLowerCase()];
  };

  checkForNewFitAttribute = ({ colorFitsSizesMap, selectedColor }) => {
    const currentColorFit = colorFitsSizesMap?.filter(
      (item) => item?.color?.name === selectedColor?.name
    );
    return currentColorFit[0]?.hasNewFitAttribute;
  };

  // eslint-disable-next-line complexity
  fitChange = (e) => {
    const { persistSelectedFit, selectedSize, selectedColor, selectedFit, selectedQuantity } =
      this.state;
    const {
      onFitChange,
      isStyleWith,
      onChangeSize,
      // eslint-disable-next-line camelcase
      currentProduct: { categoryPathMap, categoryPath3_catMap },
      currentProduct,
      isQuickView,
      isUserPersonalizationEnabled,
      isOutfitPage,
      isMultiItemQVModal,
      isBopisPickupSelected,
      isPickup,
      isBossEditModalOpen,
    } = this.props;

    // eslint-disable-next-line camelcase
    const categoryMap = categoryPathMap || categoryPath3_catMap;
    let fitVal = isStyleWith ? e.target.value : e;
    let isLoadTime = false;
    if (isUserPersonalizationEnabled && typeof e === 'object') {
      fitVal = e.name;
      ({ isLoadTime } = e);
    } else if (typeof fitVal === 'object') {
      fitVal = fitVal.name;
    }
    if (!isOutfitPage && !isMultiItemQVModal && !isLoadTime && fitVal) {
      if (persistSelectedFit && persistSelectedFit !== selectedFit) {
        setUserSelection(categoryMap, { fit: persistSelectedFit.name });
      } else {
        setUserSelection(categoryMap, { fit: fitVal });
      }
    }
    if (fitVal) {
      if (persistSelectedFit?.name !== fitVal?.toLowerCase()) {
        this.setState(
          {
            selectedFit: {
              name: fitVal,
            },
            fitChanged: true,
            isErrorMessageDisplayed: false,
          },
          this.updateSelectedSize
        );
      } else {
        this.setState(
          {
            selectedFit: {
              name: fitVal,
            },
            fitChanged: false,
            isErrorMessageDisplayed: false,
          },
          this.updateSelectedSize
        );
      }
    }

    if (onFitChange && fitVal) {
      onFitChange(fitVal);
    }

    this.setState({
      isATBErrorMessageDisplayed: false,
    });
    if (isStyleWith) {
      this.triggerGAanalytics();
    }
    if (
      isClient() &&
      selectedSize?.name &&
      fitVal !== selectedFit?.name &&
      fitVal &&
      this.getFilterSizeList(fitVal).length === 0 &&
      !(isBopisPickupSelected && isPickup) &&
      !isBossEditModalOpen
    ) {
      onChangeSize(
        selectedColor && selectedColor.name,
        '',
        selectedFit && selectedFit.name,
        selectedQuantity
      );
      if (isQuickView) {
        this.onUpdateSize('', currentProduct?.generalProductId);
      }

      this.setState({ selectedSize: { name: '' } });
    }
  };

  resetSize = (updatedSizeList) => {
    const { currentProduct, isQuickView } = this.props;
    const { selectedSize } = this.state;
    let currentSize = '';
    if (isQuickView || (selectedSize && selectedSize.name)) {
      currentSize = selectedSize?.name || '';
    } else {
      currentSize = this.initialValuesFormHolder?.Size?.name;
    }

    const generalProductId = currentProduct && currentProduct?.generalProductId;
    const sizeObj = JSON.parse(JSON.stringify(updatedSizeList));
    const isDisabledSizeSelected = Array.isArray(sizeObj)
      ? sizeObj.filter((size) => size?.displayName === currentSize && !size.disabled)
      : [];
    if (isClient() && (currentSize || currentSize?.name) && isDisabledSizeSelected.length === 0) {
      this.onUpdateSize('', generalProductId);
      this.setState({ selectedSize: { name: '' } });
    }
  };

  // TODO: Create a generic reset size function for all delivery methods
  resetSTHSize = (updatedSizeList) => {
    const { currentProduct, isQuickView, formValues } = this.props;
    const { selectedSize } = this.state;
    let currentSize = '';
    if (isQuickView || (selectedSize && selectedSize.name)) {
      currentSize = selectedSize?.name || '';
    } else {
      currentSize = this.initialValuesFormHolder?.Size?.name;
    }
    const generalProductId = currentProduct && currentProduct?.generalProductId;
    let count = 0;

    const parsedSizeList = JSON.parse(JSON.stringify(updatedSizeList));

    // Adding a condition here to return [] if we don't have parsedSizeList. At times we were getting updatedSizeList as false.
    const isDisabledSizeSelected = parsedSizeList
      ? parsedSizeList.filter((size) => {
          const isSizeNameAvailable = size?.displayName === currentSize;
          count = isSizeNameAvailable ? count : count + 1;
          return isSizeNameAvailable && !size.disabled;
        })
      : [];

    // Adding array check as we get formValues in Array format in QuickView and at other places we directly get object.
    const updatedFormValues = Array.isArray(formValues) ? formValues[0] : formValues;

    const sizeListLength = parsedSizeList ? parsedSizeList?.length : 0;

    const isSizeNotAvailableInSizeList = count === sizeListLength;

    // Adding count check for checking whether the selected size's name is present in the sizeList. currentSize will give us the selectedSize's name. updatedFormValues?.size is required in case the redux form's size was not cleared for the given product.
    if (
      isClient() &&
      (currentSize || updatedFormValues?.size) &&
      (isSizeNotAvailableInSizeList || isDisabledSizeSelected.length === 0)
    ) {
      this.onUpdateSize('', generalProductId);
      this.setState({ selectedSize: { name: '' } });
    }
  };

  resetBopisSize = (updatedSizeList) => {
    const { currentProduct, isQuickView } = this.props;
    const { selectedSize } = this.state;
    let currentSize = '';
    if (isQuickView || (selectedSize && selectedSize.name)) {
      currentSize = selectedSize?.name || '';
    } else {
      currentSize = this.initialValuesFormHolder?.Size?.name;
    }
    const generalProductId = currentProduct && currentProduct?.generalProductId;
    const sizeObj = JSON.parse(JSON.stringify(updatedSizeList));
    const isDisabledSizeSelected = sizeObj
      ? sizeObj.filter((size) => size?.displayName === currentSize)
      : [];
    if (isClient() && currentSize && isDisabledSizeSelected.length === 0) {
      this.onUpdateSize('', generalProductId);
      this.setState({ selectedSize: { name: '' } });
    }
  };

  getAlternateStyleBasedOnSelectedColor = (allProductId, pickedProdcut) => {
    return productUtil.getAlternateStyleBasedOnSelectedColor(allProductId, pickedProdcut);
  };

  getUpdatedSelectedSize = ({ isPickupModalOpen, selectedColor, selectedSize }) => {
    if (isPickupModalOpen) {
      return selectedColor?.[0]?.miscInfo?.isBopisEligible ? selectedSize : '';
    }
    return selectedSize;
  };

  colorChangeFunc = (e, colorIndex) => {
    const { selectedSize, selectedFit, selectedQuantity, isBopisSelected } = this.state;
    const {
      onChangeColor,
      currentProduct: { colorFitsSizesMap, allProductId },
      setAlternateStylesAct,
      isPDP,
      outfitV3WidgetVDABTestEnabled,
      outfitV3WidgetMnMABTest,
      outfitV3WidgetEnabled,
      setStyliticsProductTabListData,
      setSelectedProductIdForOutfit,
      isPickupModalOpen,
      isSplittingExtendedSizesEnabled,
      generalProductId,
    } = this.props;
    const selectedColor = this.getSelectedColorData(colorFitsSizesMap, e);
    const isNewFitsAttributePresent = this.checkForNewFits({
      isSplittingExtendedSizesEnabled,
      colorFitsSizesMap,
      selectedColor: { name: e },
    });

    const selectedSizeNew = this.getUpdatedSelectedSize({
      isPickupModalOpen,
      selectedColor,
      selectedSize,
    });

    const selectedColorArray = selectedColor && selectedColor[0];
    this.setState({
      selectedColor: { name: e },
      selectedSize: selectedSizeNew,
      isErrorMessageDisplayed: false,
      fitChanged: selectedSize?.name === '',
      keepAlive: selectedColorArray && selectedColorArray.miscInfo.keepAlive,
      selectedProductColorIndex: selectedColorArray && selectedColorArray.colorProductId,
    });
    if (onChangeColor) {
      const selectedColorName = colorIndex;
      const currentColorEntry = colorFitsSizesMap?.find(
        (colorEntry) => colorEntry?.color?.name === selectedColorName
      );
      const selectedFitName = typeof selectedFit === 'object' ? selectedFit?.name : selectedFit;
      if (selectedFitName) {
        const isSelectedFitAvailable = currentColorEntry?.fits?.find(
          (fit) => fit?.fitName === selectedFitName
        );
        if (!isSelectedFitAvailable) {
          const timer = setTimeout(() => {
            this.setState({ selectedFit: { name: '' } });
            this.onUpdateFit(null);
            clearTimeout(timer);
          }, 0);
        }
      }
      onChangeColor(
        e,
        selectedSizeNew && selectedSizeNew?.name,
        selectedFit && selectedFit.name,
        selectedQuantity,
        colorIndex
      );
      if (isNewFitsAttributePresent) {
        this.onUpdateFit(selectedFitName);
        if (!selectedFitName) {
          const fitNameToSelect = currentColorEntry?.fits[0]?.fitName;
          this.onUpdateFit(fitNameToSelect);
        }
        this.onUpdateSize('', generalProductId);
        this.onUpdateSize({ selectedSize: { name: '' } });
      }

      if (isPDP) {
        const colorBasedAlternateStyle =
          this.getAlternateStyleBasedOnSelectedColor(
            allProductId,
            currentColorEntry?.colorProductId
          ) || {};
        setAlternateStylesAct({ ...colorBasedAlternateStyle });
        if (outfitV3WidgetEnabled) {
          loadOutfitV3(
            currentColorEntry.colorProductId,
            outfitV3WidgetVDABTestEnabled,
            outfitV3WidgetMnMABTest,
            setStyliticsProductTabListData,
            setSelectedProductIdForOutfit
          );
        }
      }

      if (!isBopisSelected) {
        this.getSizeOptions(selectedColorArray, selectedFit, true);
      }
    }
  };

  colorChange = (e, colorIndex) => {
    setTimeout(() => {
      this.colorChangeFunc(e, colorIndex);
    }, 0);
  };

  PDPlargeImageChangeOnHover = (e) => {
    const { setPDPLargeImage } = this.props;
    setPDPLargeImage(e?.target?.offsetParent?.innerText);
  };

  PDPlargeImageResetOnHoverOut = () => {
    const { setPDPLargeImage } = this.props;
    setPDPLargeImage('');
  };

  checkHasFits = (selectedColorElement) => {
    return (
      selectedColorElement &&
      selectedColorElement.length > 0 &&
      selectedColorElement[0].hasFits &&
      selectedColorElement[0].fits &&
      selectedColorElement[0].fits[0].fitName
    );
  };

  isSizePresent = (sizeListTemp) => {
    const { formValues } = this.props;
    if (formValues && formValues?.size && sizeListTemp) {
      const found = sizeListTemp?.find((item) => item?.displayName === formValues?.size);
      if (found) {
        return true;
      }
    }
    return false;
  };

  /**
   * @function getSizeList
   * @returns size list for selected fit
   *
   * @memberof ProductAddToBagContainer
   */
  getSizeList = (colorFitsSizesMap, updatedSelectedColor) => {
    const { selectedColor, selectedFit } = this.state;
    const selectedProductAvailable =
      colorFitsSizesMap &&
      colorFitsSizesMap.find(
        (entry) => entry.color.name === (updatedSelectedColor && updatedSelectedColor.name)
      );

    const newSelectedProductName = selectedProductAvailable ? updatedSelectedColor : selectedColor;

    const selectedColorElement = this.getSelectedColorData(
      colorFitsSizesMap,
      newSelectedProductName
    );
    const hasFits = this.checkHasFits(selectedColorElement);

    const sizeListTemp =
      selectedColorElement &&
      selectedColorElement.length > 0 &&
      (hasFits
        ? this.getSizeOptions(selectedColorElement[0], selectedFit)
        : this.getSizeOptions(selectedColorElement[0]));
    if (!isEqual(sizeListTemp, this.sizeListHolder)) {
      this.sizeListHolder = sizeListTemp;
    }

    return this.sizeListHolder;
  };

  getUpdatedSizeList = (colorFitsSizesMap, updatedSelectedColor, selectedFit) => {
    const { selectedColor } = this.state;
    const selectedProductAvailable =
      colorFitsSizesMap &&
      colorFitsSizesMap.find(
        (entry) => entry.color.name === (updatedSelectedColor && updatedSelectedColor.name)
      );
    const newSelectedProductName = selectedProductAvailable ? updatedSelectedColor : selectedColor;

    const selectedColorElement = this.getSelectedColorData(
      colorFitsSizesMap,
      newSelectedProductName
    );
    const hasFits = this.checkHasFits(selectedColorElement);

    return (
      selectedColorElement &&
      selectedColorElement.length > 0 &&
      (hasFits
        ? this.getSizeOptions(selectedColorElement[0], selectedFit)
        : this.getSizeOptions(selectedColorElement[0]))
    );
  };

  getSizeOptions = (colorItem, selectedFit, isColorChange = false) => {
    const { isBopisSelected } = this.state;
    const {
      fits,
      miscInfo: { isBossEligible },
      colorProductId,
    } = colorItem;
    let sizeOptions = [];
    if (colorItem && fits && fits.length) {
      fits.forEach((fit) => {
        if (selectedFit) {
          if (fit.fitName === selectedFit.name) {
            sizeOptions = this.getFitSizeMap(fit, isBossEligible, colorProductId);
          }
        } else {
          sizeOptions = this.getFitSizeMap(fit, isBossEligible, colorProductId);
        }
      });
    }
    if (!isBopisSelected) this.getErrorCheck(sizeOptions, selectedFit);
    sizeOptions =
      colorItem.hasFits && sizeOptions && sizeOptions.length === 0
        ? this.getSizeForSecondOption(fits, isBossEligible)
        : sizeOptions;

    if (!isBopisSelected) this.deselectSize(sizeOptions, isColorChange);

    return sizeOptions;
  };

  deselectSize = (sizeOptions, isColorChange = false) => {
    const {
      formValues,
      onChangeSize,
      isShowDisabledSize,
      deliveryType,
      currentProduct,
      isBossMultiStoreEnabled,
    } = this.props;
    const { isBossSelected } = this.state;

    const updatedFormValues = Array.isArray(formValues) ? formValues[0] : formValues;

    const selSize = sizeOptions.find((size) => size.displayName === updatedFormValues?.size);

    const generalProductId = currentProduct && currentProduct.generalProductId;
    if (
      updatedFormValues &&
      (selSize?.disabled || (isColorChange && !selSize)) &&
      isBossSelected &&
      isBossMultiStoreEnabled
    ) {
      this.onUpdateSize('', generalProductId);
      this.setState({ selectedSize: { name: '' } });
    }

    if (
      updatedFormValues &&
      updatedFormValues.size &&
      typeof updatedFormValues.size === 'string' &&
      deliveryType === 'shipIt' &&
      (selSize?.disabled || (isColorChange && !selSize)) &&
      onChangeSize &&
      !isShowDisabledSize
    ) {
      onChangeSize(null, '');
    }
  };

  setIsBopisSelected = (isBopisSelected) => {
    const { updatePickupSelectedAtProductDetail } = this.props;
    this.setState({ isBopisSelected });
    updatePickupSelectedAtProductDetail(isBopisSelected);
  };

  setIsSTHSelected = (isSTHSelected) => {
    this.setState({ isSTHSelected });
  };

  setIsBossSelected = (isBossSelected) => {
    this.setState({ isBossSelected });
  };

  getSizeForSecondOption = (fits, isBossEligible) => {
    let sizeOptions = [];
    fits.forEach((fit) => {
      sizeOptions = this.getFitSizeMap(fit, isBossEligible);
    });
    this.setState({
      selectedFit: {
        name: fits[0].fitName,
      },
    });
    return sizeOptions;
  };

  getMultipackObj = () => {
    const { getAllNewMultiPack } = this.props;
    if (getAllNewMultiPack && getAllNewMultiPack.length) {
      return getAllNewMultiPack.reduce((allPack, multipack) => {
        if (!multipack || !multipack.variants) return allPack;
        const newMultipack = allPack;
        if (!newMultipack[multipack.prodpartno]) {
          const updatedVariants = multipack.variants.reduce((allVariants, variant) => {
            return variant &&
              (!allVariants[variant.v_tcpsize] || allVariants[variant.v_tcpsize]?.v_qty === 0)
              ? { ...allVariants, [variant.v_tcpsize]: { ...variant } }
              : allVariants;
          }, {});
          newMultipack[multipack.prodpartno] = {
            ...multipack,
            variants: updatedVariants,
          };
        }
        return newMultipack;
      }, {});
    }
    return getAllNewMultiPack;
  };

  getSelectedProd = (getMultiPackAllColor) => {
    const { selectedColor } = this.state;
    return Array.isArray(getMultiPackAllColor)
      ? getMultiPackAllColor.find(
          (product) =>
            product.name === selectedColor.name ||
            `${product.name}-${product.prodpartno}` === selectedColor.name
        )
      : '';
  };

  getIsPDPMicroServiceEnabled = () => {
    const { isPDPServiceEnabled, isABTestPdpService } = this.props;
    if (isNewVendorEnabled()) {
      return true;
    }
    return isPDPServiceEnabled && isABTestPdpService;
  };

  getCorrectSizeNameWithPrefix = (variantsObject, sizeId) => {
    const variantKeys = Object.keys(variantsObject);
    const isPDPMicroServiceEnabled = this.getIsPDPMicroServiceEnabled();
    const correctSizeName =
      variantKeys &&
      variantKeys.filter((item) => {
        if (isPDPMicroServiceEnabled) {
          return item === sizeId;
        }
        return item && item.split('_')[1] === sizeId;
      });
    return correctSizeName && correctSizeName[0];
  };

  checkBossSelected = () => {
    const { isPickup } = this.props;
    return isPickup ? getSessionStorage('pickupValue') === 'boss' : '';
  };

  getIsSizeUnavailable = (multipackObj, currentMultipack, size, thresholdCount) => {
    const { selectedQuantity, isBossSelected } = this.state;
    const { isPickUpSelected, isBossPickupEdit } = this.props;
    const selectedPickUpBoss = this.checkBossSelected();
    const isBossItem =
      isBossSelected || selectedPickUpBoss || isPickUpSelected === 'boss' || isBossPickupEdit;
    const qtyParam = isBossItem ? 'v_qty_boss' : 'v_qty';
    let maxAvailable = 0;
    const isSizeNotAvailable = multipackObj
      ? currentMultipack.some((multipack) => {
          const [partNo, quantity] = multipack.split('#');
          const correctSizeName = this.getCorrectSizeNameWithPrefix(
            multipackObj[partNo] && multipackObj[partNo].variants,
            size.id
          );
          const availableQty = multipackObj?.[partNo]?.variants?.[correctSizeName]?.[qtyParam] || 0;
          if (maxAvailable === 0 || availableQty < maxAvailable) {
            maxAvailable = availableQty;
          }
          return (
            availableQty / parseInt(quantity, 10) - parseInt(selectedQuantity, 10) < thresholdCount
          );
        })
      : true;

    return {
      isSizeNotAvailable,
      maxAvailable,
    };
  };

  getIsVirtualStyle = (selectedProd) =>
    isCanada()
      ? selectedProd.styleTypeCA === '0002' || selectedProd.styleTypeCA === '0003'
      : selectedProd.styleTypeUS === '0002' || selectedProd.styleTypeUS === '0003';

  getSizeId = (size) => {
    return size && size.id;
  };

  getSelectedProductDetails = (selectedProd, isPDPMicroServiceEnabled, size) => {
    return (
      selectedProd &&
      selectedProd.variants &&
      selectedProd.variants.filter((item) => {
        const correctSizeName = isPDPMicroServiceEnabled
          ? item && item.v_tcpsize
          : item && item.v_tcpsize && item.v_tcpsize.split('_')[1];
        return correctSizeName === this.getSizeId(size);
      })
    );
  };

  isVMPBossEligible = (size) => {
    try {
      const { multiPackThreshold, currentProduct: { getMultiPackAllColor } = {} } = this.props;
      const isPDPMicroServiceEnabled = this.getIsPDPMicroServiceEnabled();

      const thresholdCount = multiPackThreshold ? parseInt(multiPackThreshold, 10) : false;
      const selectedProd = this.getSelectedProd(getMultiPackAllColor);
      const isVirtualStyle = selectedProd && this.getIsVirtualStyle(selectedProd);
      const selectedColorProductInfo = getMultiPackAllColor?.find(
        (colorProduct) => colorProduct?.name === this.selectedColorHolder?.name
      );
      const isVMPEnabled = parseBoolean(selectedColorProductInfo?.isVMPEnabled);

      if (isVirtualStyle) {
        const selectedProductDetails = this.getSelectedProductDetails(
          selectedProd,
          isPDPMicroServiceEnabled,
          size
        );
        const availableVBossQuantity =
          selectedProductDetails &&
          selectedProductDetails[0] &&
          selectedProductDetails[0].v_qty_boss;
        if (availableVBossQuantity !== 8888 && availableVBossQuantity > 0) {
          return availableVBossQuantity;
        }
      }
      const currentMultipack =
        selectedProd && selectedProd.TCPMultiPackReferenceUSStore
          ? selectedProd.TCPMultiPackReferenceUSStore.split(',')
          : [];
      if (thresholdCount) {
        const multipackObj = this.getMultipackObj();
        const { isSizeNotAvailable, maxAvailable } = this.getIsSizeUnavailable(
          multipackObj,
          currentMultipack,
          size,
          thresholdCount
        );
        return isVMPEnabled && !isSizeNotAvailable ? maxAvailable : 0;
      }
      return false;
    } catch (err) {
      return false;
    }
  };

  isSizeAvailable = (size) => {
    try {
      const { multiPackThreshold, currentProduct: { getMultiPackAllColor } = {} } = this.props;
      const isPDPMicroServiceEnabled = this.getIsPDPMicroServiceEnabled();

      const thresholdCount = multiPackThreshold ? parseInt(multiPackThreshold, 10) : false;
      const selectedProd = this.getSelectedProd(getMultiPackAllColor);
      const isVirtualStyle = selectedProd && this.getIsVirtualStyle(selectedProd);
      if (isVirtualStyle) {
        const selectedProductDetails = this.getSelectedProductDetails(
          selectedProd,
          isPDPMicroServiceEnabled,
          size
        );
        const availableQuantity =
          selectedProductDetails && selectedProductDetails[0] && selectedProductDetails[0].v_qty;
        if (availableQuantity !== 8888 && availableQuantity > 0) {
          return availableQuantity;
        }
      }
      const currentMultipack =
        selectedProd && selectedProd.TCPMultiPackReferenceUSStore
          ? selectedProd.TCPMultiPackReferenceUSStore.split(',')
          : [];
      if (thresholdCount) {
        const multipackObj = this.getMultipackObj();
        const { isSizeNotAvailable, maxAvailable } = this.getIsSizeUnavailable(
          multipackObj,
          currentMultipack,
          size,
          thresholdCount
        );
        return !isSizeNotAvailable ? maxAvailable : 0;
      }
      return false;
    } catch (err) {
      return false;
    }
  };

  oldFitMap = (fit) => {
    const { isBossSelected } = this.state;
    const { isPickUpSelected, isBossPickupEdit } = this.props;

    const selectedPickUpBoss = this.checkBossSelected();
    return fit.sizes.map((size) => {
      return {
        displayName: size.sizeName,
        id: size.sizeName,
        maxAvailable:
          isBossSelected || selectedPickUpBoss || isPickUpSelected === 'boss' || isBossPickupEdit
            ? size?.maxAvailableBoss
            : size?.maxAvailable,
        maxAvailableInBopisStore: size.maxAvailableInBopisStore,
        disabled: size.maxAvailable <= 0,
        multipackVariant: size.isMultiPack,
        variantId: size.variantId,
        socialProofingQty: size.socialProofingQty,
        showInStoreMsg: !!(size?.maxAvailableBoss <= 0 && size?.maxAvailable <= 0),
      };
    });
  };

  newFitMap = (oldFit) => {
    return oldFit.map((size) => {
      if (size.multipackVariant) {
        const { displayName, disabled, showInStoreMsg, socialProofingQty } = size;
        const maxAvailableValue = this.isSizeAvailable(size);
        return {
          displayName,
          id: displayName,
          maxAvailable: maxAvailableValue,
          disabled,
          maxAvailableInBopisStore: size.maxAvailableInBopisStore,
          showInStoreMsg,
          socialProofingQty,
        };
      }
      return null;
    });
  };

  getBossQty = (size) => {
    const availableVBossQuantity = this.isVMPBossEligible(size);
    return availableVBossQuantity || 0;
  };

  findVariant = (data, uniqueId, variantId) => {
    const matchedObject = data?.find((obj) => obj.uniqueId === uniqueId);

    if (matchedObject && matchedObject.variants) {
      const matchedVariant = matchedObject.variants.find(
        (variant) => variant.variantId === variantId
      );

      if (matchedVariant && Object.keys(matchedVariant).some((key) => key.includes('v_Quantity'))) {
        // Key containing 'v_Quantity' found, return its value
        return matchedVariant[
          Object.keys(matchedVariant).find((key) => key.includes('v_Quantity'))
        ];
      }
      // Key containing 'v_Quantity' not found, return 0
      return 0;
    }

    return 0;
  };

  sizeDisabledCheck = ({
    newsize,
    isBossSelected,
    checkMultipack,
    selectedQuantity,
    isBossEligible,
  }) => {
    const selectedPickUpBoss = this.checkBossSelected();
    if (selectedPickUpBoss && !isBossEligible) return true;
    if ((isBossSelected || selectedPickUpBoss) && checkMultipack) {
      return !newsize?.bossQty;
    }
    return newsize?.maxAvailable <= 0 || newsize?.maxAvailable < selectedQuantity;
  };

  updatePickupSelectedState = (value) => {
    this.setState({
      pickupSelectedState: value,
    });
  };

  getFitSizeMap = (fit, isBossEligible, colorProductId) => {
    const {
      multipackProduct,
      currentProduct: { getMultiPackAllColor } = {},
      isPickUpSelected,
      isBossPickupEdit,
      isPickupPromotionPDPEnabled,
      storeSpecificVariants,
      isPDP,
    } = this.props;
    const { isBossSelected, isBopisSelected, selectedSize, pickupSelectedState } = this.state;
    const { selectedQuantity } = this.state;
    const checkMultipack = !!multipackProduct && multipackProduct.length > 0;
    const oldFit = this.oldFitMap(fit);
    const newFit = checkMultipack && this.newFitMap(oldFit);
    const data =
      checkMultipack &&
      newFit.filter((element) => {
        return element !== null;
      });
    const isBoss = isBossSelected || isPickUpSelected === 'boss' || isBossPickupEdit;
    const getData = data?.length > 0 ? data : oldFit;
    getData?.forEach((newsize) => {
      // eslint-disable-next-line no-param-reassign
      newsize.bossQty = this.getBossQty(newsize, getMultiPackAllColor);
    });

    return getData?.map((originalNewsize) => {
      let maxAvailableInBopisStore1;
      const newsize = { ...originalNewsize };
      if (isPickupPromotionPDPEnabled && isPDP) {
        const products = storeSpecificVariants?.products;

        if (products) {
          maxAvailableInBopisStore1 = this.findVariant(products, colorProductId, newsize.variantId);
          newsize.maxAvailableInBopisStore = maxAvailableInBopisStore1;
        }
      }

      const result = {
        displayName: newsize.displayName,
        id: newsize.displayName,
        maxAvailable: newsize.maxAvailable,
        socialProofingQty: newsize.socialProofingQty,
        disabled: this.sizeDisabledCheck({
          newsize,
          isBoss,
          checkMultipack,
          selectedQuantity,
          isBossEligible,
        }),
      };

      if (
        (isBopisSelected || pickupSelectedState === 'bopis') &&
        isPickupPromotionPDPEnabled &&
        isPDP
      ) {
        result.softDisable =
          newsize?.maxAvailableInBopisStore <= 0 && newsize.displayName !== selectedSize?.name;
        result.maxAvailableInBopisStore = newsize.maxAvailableInBopisStore;
        result.showInStoreMsg = newsize?.showInStoreMsg;
      }
      return result;
    });
  };

  getErrorCheck = (sizeOptions = [], selectedFit) => {
    const { selectedSize } = this.state;

    const option = this.getOptionArray(sizeOptions);

    const fitOption = this.getFitOptionsArray(selectedFit, selectedSize, sizeOptions);
    this.setErrorState(fitOption);

    if (
      option &&
      option.length > 0 &&
      selectedSize &&
      option[0].displayName === selectedSize?.name
    ) {
      this.setState({
        fitChanged: true,
      });
    } else if (selectedSize?.name && !selectedFit) {
      this.setState({
        fitChanged: false,
      });
      const selectedSizeObj = sizeOptions.filter(
        (sizeItem) => (sizeItem && sizeItem.displayName) === (selectedSize && selectedSize?.name)
      );
      const isSizeAvailable = sizeOptions?.some((sizeItem) => {
        return (sizeItem && sizeItem.displayName) === (selectedSize && selectedSize.name);
      });
      if (!isSizeAvailable) {
        return;
      }
      if (!(selectedSizeObj && selectedSizeObj[0] && selectedSizeObj[0].disabled)) {
        this.displayErrorMessage(false);
      }
    }
  };

  getOptionArray = (sizeOptions) =>
    sizeOptions.length > 0 && sizeOptions.filter((item) => item.maxAvailable <= 0);

  getFitOptionsArray = (selectedFit, selectedSize, sizeOptions) =>
    selectedFit &&
    selectedSize?.name &&
    sizeOptions.length > 0 &&
    sizeOptions.filter((item) => item.displayName === selectedSize?.name);

  setErrorState = (fitOption) => {
    if (fitOption && fitOption.length === 0) {
      this.setState({
        fitChanged: true,
      });
    } else if (fitOption && fitOption.length === 1) {
      this.setState({
        fitChanged: false,
      });
    }
  };

  displayErrorMessage = (displayError) => {
    this.setState({
      isErrorMessageDisplayed: displayError,
    });
  };

  displayAccessoriesErrorMessage = (selectedAccessories) => {
    if (selectedAccessories.length === 0) {
      this.setState({
        isAccessoryMessageDisplayed: true,
      });
    }
  };

  displayATBErrorMessage = (displayError) => {
    this.setState({
      isATBErrorMessageDisplayed: displayError,
    });
  };

  /**
   * @function getQuantityList
   * @returns quantity list with labels and values to render dropdown
   *
   * @memberof ProductAddToBagContainer
   */
  getQuantityList = () => {
    const quantityArray = new Array(15).fill(1);
    const quantityArrayTemp = quantityArray.map((val, index) => ({
      displayName: index + 1,
      id: index + 1,
    }));
    if (!isEqual(this.quantityListHolder, quantityArrayTemp)) {
      this.quantityListHolder = quantityArrayTemp;
    }
    return this.quantityListHolder;
  };

  getSelectedColorData = (colorFitsSizesMap, selectedColor = {}) => {
    return (
      colorFitsSizesMap &&
      colorFitsSizesMap.filter((colorItem) => {
        const {
          color: { name },
        } = colorItem;
        return (selectedColor.name || selectedColor) === name;
      })
    );
  };

  getFitOptions = (colorFitsSizesMap, selectedColor, updatedSelectedColor) => {
    const selectedProductAvailable =
      colorFitsSizesMap &&
      colorFitsSizesMap.find(
        (entry) => entry.color.name === (updatedSelectedColor && updatedSelectedColor.name)
      );
    const newSelectedProductName = selectedProductAvailable ? updatedSelectedColor : selectedColor;
    const colorItem = this.getSelectedColorData(colorFitsSizesMap, newSelectedProductName);
    const { fits, hasFits } = (colorItem && colorItem[0]) || {};
    const fitsTemp =
      (fits &&
        fits[0].fitName &&
        hasFits &&
        fits.map((fit) => ({
          displayName: fit.fitName,
          id: fit.fitName,
        }))) ||
      [];
    if (!isEqual(fitsTemp, this.fitListHolder)) {
      this.fitListHolder = fitsTemp;
    }
    return this.fitListHolder;
  };

  getNewFitOptions = (colorFitsSizesMap, selectedColor, updatedSelectedColor) => {
    const selectedProductAvailable =
      colorFitsSizesMap &&
      colorFitsSizesMap.find(
        (entry) => entry.color.name === (updatedSelectedColor && updatedSelectedColor.name)
      );
    const newSelectedProductName = selectedProductAvailable ? updatedSelectedColor : selectedColor;
    const colorItem = this.getSelectedColorData(colorFitsSizesMap, newSelectedProductName);
    const { newFitList, newFitProductMap } = (colorItem && colorItem[0]) || {};
    const fitsTemp = newFitList;

    if (!isEqual(fitsTemp, this.fitListHolder)) {
      this.newFitListHolder = fitsTemp;
    }
    return { newSelectedProductFitList: this.newFitListHolder, newFitProductMap };
  };

  shouldSuppressOOSFitsWithoutChecks = () => {
    const {
      isSuppressOOSFitsEnabled,
      currentProduct: { colorFitsSizesMap },
    } = this.props;

    const { selectedColor } = this.state;

    const colorItem = this.getSelectedColorData(colorFitsSizesMap, selectedColor);
    const { hasFits, fits } = (colorItem && colorItem[0]) || {};

    if (isSuppressOOSFitsEnabled && hasFits && fits?.length > 1) {
      return true;
    }

    return false;
  };

  shouldSuppressOOSFits = () => {
    const {
      isSuppressOOSFitsEnabled,
      isPDP,
      isQuickView,
      currentProduct: { colorFitsSizesMap },
    } = this.props;

    const { isSTHSelected, selectedColor } = this.state;

    const isShipToHomeSelectedWeb = (isPDP || isQuickView) && isSTHSelected;

    const shipToHomeCheck = isShipToHomeSelectedWeb;

    const colorItem = this.getSelectedColorData(colorFitsSizesMap, selectedColor);
    const { hasFits, fits } = (colorItem && colorItem[0]) || {};

    if (isSuppressOOSFitsEnabled && shipToHomeCheck && hasFits && fits?.length > 1) {
      return true;
    }

    return false;
  };

  getColorFitsSizesMapWithoutOOSFits = () => {
    const {
      currentProduct: { colorFitsSizesMap },
    } = this.props;
    const { selectedColor } = this.state;
    return colorFitsSizesMap?.map((item) => {
      const {
        color: { name },
        fits,
        miscInfo: { isBossEligible },
        colorProductId,
      } = item;
      if ((selectedColor.name || selectedColor) === name) {
        const newFits = [];

        for (let i = 0; i < fits.length; i += 1) {
          const sizeList = this.getFitSizeMap(fits[i], isBossEligible, colorProductId);
          for (let j = 0; j < sizeList?.length; j += 1) {
            if (sizeList[j].maxAvailable > 0 && sizeList[j].maxAvailable !== 8888) {
              newFits.push(fits[i]);
              break;
            }
          }
        }
        if (newFits.length === 0) {
          return { ...item, fits: [fits[0]] };
        }
        return { ...item, fits: newFits };
      }

      return item;
    });
  };

  getSelectedSize = (sizeVal, prevSelectedSize, isWebStyleWith, isOutfitPage) => {
    return sizeVal === prevSelectedSize?.name && !isWebStyleWith && isOutfitPage ? '' : sizeVal;
  };

  onUpdateSize = (size, productId) => {
    const { updateSize } = this.props;
    const form = this.getFormNameProductAddToBag(productId);
    updateSize({ form, size });
  };

  onUpdateColor = (color, newProductId) => {
    const { updateColor } = this.props;
    const form = this.getFormNameProductAddToBag(newProductId);
    updateColor({ form, color });
  };

  onUpdateFit = (fit) => {
    const { updateFit } = this.props;
    const form = this.getFormNameProductAddToBag();
    updateFit({ form, fit });
  };

  resetFormValues = (color, productId) => {
    const { updateColor, updateSize, updateFit } = this.props;
    const form = this.getFormNameProductAddToBag(productId);
    if (form && form !== '') {
      updateColor({ form, color: {} });
      updateSize({ form, size: '' });
      updateFit({ form, fit: '' });
    }
  };

  sizeChange = (e, disabled) => {
    const {
      selectedColor,
      selectedFit,
      selectedQuantity,
      selectedSize: prevSelectedSize,
    } = this.state;
    const {
      onChangeSize,
      getSKUValidated,
      isStyleWith,
      isOutfitPage,
      updateSizeStatus,
      isVMPBOSSEnabled,
    } = this.props;
    const isWebStyleWith = isStyleWith;
    let sizeVal = isWebStyleWith ? e.target.value : e;
    if (e?.keyCode === 13 || e?.key === 'Enter') {
      sizeVal = e?.target?.innerText;
    }

    let vmpBossEligible;
    if (isVMPBOSSEnabled) {
      const VBossQty = this.isVMPBossEligible({ id: sizeVal });
      vmpBossEligible = VBossQty && VBossQty > 0;
      this.setState({ isVMPBossEligible: vmpBossEligible });
    }
    this.setState({
      persistSelectedFit: selectedFit,
      selectedSize: {
        name: this.getSelectedSize(sizeVal, prevSelectedSize, isWebStyleWith, isOutfitPage),
      },
      fitChanged: false,
      isATBErrorMessageDisplayed: false,
    });
    if (e !== 'Select') {
      this.displayErrorMessage(false);
      if (getSKUValidated) {
        getSKUValidated(false);
      }
    }
    updateSizeStatus(disabled);
    if (onChangeSize) {
      onChangeSize(
        selectedColor && selectedColor.name,
        sizeVal,
        selectedFit && selectedFit.name,
        selectedQuantity,
        vmpBossEligible
      );
    }
    if (isStyleWith) {
      this.triggerGAanalytics();
    }
  };

  quantityChange = (selectedQuantity, form) => {
    const { quantityChange, updateQuantityChange } = this.props;
    quantityChange({ form, selectedQuantity });
    this.setState({ selectedQuantity, isATBErrorMessageDisplayed: false });
    if (updateQuantityChange) {
      updateQuantityChange(selectedQuantity);
    }
  };

  quickViewPickup = () => {
    const { isPickup, isMultiItemQVModal, isBundleProduct, isFavoriteEdit } = this.props;
    const isQuickViewPickup = !isPickup && !isBundleProduct && !isMultiItemQVModal;
    if (isFavoriteEdit) {
      return isFavoriteEdit && !isFavoriteEdit;
    }
    return isQuickViewPickup;
  };

  checkOOS = (multipackProduct) => {
    if (multipackProduct && multipackProduct.length > 0) {
      return multipackProduct.map((finalData) => {
        return finalData.v_qty === 0
          ? CONSTANT.PRODUCT_ADD_TO_BAG_UNAVAILABLE
          : CONSTANT.PRODUCT_ADD_TO_BAG_AVAILABLE;
      });
    }
    return null;
  };

  regularProduct = (availableFlag, multipackProduct) => {
    return availableFlag === -1 && multipackProduct === null;
  };

  getCurrentProductId = (updatedColorEntry, selectedColorProductId) => {
    return updatedColorEntry ? updatedColorEntry.colorDisplayId : selectedColorProductId;
  };

  checkForOOSForAllVariants = () => {
    const {
      currentProduct: { categoryIdList },
      multipackProduct,
    } = this.props;
    let availableFlagMultipack;
    if (categoryIdList && categoryIdList.length > 0) {
      const isOOSForAllVariantsMultipack = this.checkOOS(multipackProduct);
      if (multipackProduct && multipackProduct.length > 0) {
        availableFlagMultipack = isOOSForAllVariantsMultipack.findIndex(
          (variantQuantity) => variantQuantity === CONSTANT.PRODUCT_ADD_TO_BAG_AVAILABLE
        );
      }
      const isOOSForAllVariantsRegular = categoryIdList.map((categoryItem) => {
        return categoryItem.v_qty === 0
          ? CONSTANT.PRODUCT_ADD_TO_BAG_UNAVAILABLE
          : CONSTANT.PRODUCT_ADD_TO_BAG_AVAILABLE;
      });

      const availableFlag = isOOSForAllVariantsRegular.findIndex(
        (variantQuantity) => variantQuantity === CONSTANT.PRODUCT_ADD_TO_BAG_AVAILABLE
      );
      const regularProduct = this.regularProduct(availableFlag, multipackProduct);
      if (regularProduct || (availableFlag === -1 && availableFlagMultipack === -1)) {
        return true;
      }
    }
    return false;
  };

  getInitalValue = (
    isQuickView,
    formValues,
    initialFormValues,
    selectedColor,
    isMultiItemQVModal
  ) => {
    let initalSelectedColor;
    if (isQuickView && !isMultiItemQVModal) {
      if (formValues && formValues[0]) {
        initalSelectedColor =
          formValues && formValues[0] && formValues[0].color ? formValues[0].color : '';
      } else {
        initalSelectedColor = formValues && formValues?.color ? formValues.color : '';
      }
    } else {
      initalSelectedColor =
        formValues && formValues.color
          ? formValues.color
          : initialFormValues && initialFormValues.color;
    }
    return initalSelectedColor || (selectedColor && selectedColor.name);
  };

  getUpdatedColor = (initalSelectedColor, selectedColor) => {
    return {
      name: initalSelectedColor || (selectedColor && selectedColor.name) || '',
    };
  };

  getAddType = (isOutfitPage, isPDP, isBundleProduct) => {
    let pageAddType = 'browse';
    if (isOutfitPage) {
      pageAddType = 'outfit';
    }
    if (isPDP) {
      pageAddType = 'product';
    }
    if (isBundleProduct) {
      pageAddType = 'productbundle';
    }
    return pageAddType;
  };

  getFromPageVal = () => {
    const { isPDP, pageName, fromPage } = this.props;
    const isPDPFlag = isPDP && pageName === 'PDP';
    if (isPDPFlag) return pageName;
    return fromPage;
  };

  /**
   * @function render
   *
   * @returns ProductAddToBag view
   * @memberof ProductAddToBagContainer
   */

  getAlternateBrand = (alternateBrand, alternateBrandFromState) => {
    return alternateBrand || alternateBrandFromState;
  };

  getSelectedColorId = (selectedColorProductId, getNewId) => {
    return selectedColorProductId || getNewId;
  };

  setSizeAvailable = (e) => {
    const { setSizeSelectAvailable } = this.props;
    setSizeSelectAvailable(e);
  };

  pickupModalOpenHandler = async (payload) => {
    const { onPickUpOpenClick } = this.props;
    await PickupStoreModalDynamicStore();
    onPickUpOpenClick(payload);
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      currentProduct,
      fromCollectionPage,
      currentProduct: {
        colorFitsSizesMap,
        colorFitSizeDisplayNames,
        isGiftCard,
        imagesByColor,
        relatedSwatchImages,
        TCPMultipackProductMapping,
        TCPStyleType,
        TCPStyleQTY,
        tcpMultiPackReferenceUSStore,
        multiPackUSStore,
        getMultiPackAllColor,
      } = {},
      handleFormSubmit,
      errorOnHandleSubmit,
      selectedColorProductId,
      customFormName,
      showAddToBagCTA = true,
      showColorChips = true,
      fromBagPage,
      productInfoFromBag,
      customSubmitButtonStyle,
      colorFitsSizesMap: favColorFitsSizesMap,
      isOutfitPage,
      formRef,
      formEnabled,
      quickViewColorSwatchesCss,
      isPDP,
      isDisableZeroInventoryEntries,
      alternateSizes,
      sizeChartLinkVisibility,
      navigation,
      isPickup,
      onCloseClick,
      isBundleProduct,
      isKeepAliveEnabled,
      isFavoriteEdit,
      sizeChartDetails,
      isMultiItemQVModal,
      pageNameProp,
      pageSectionProp,
      pageSubSectionProp,
      itemBrand,
      showAddedToBagCta,
      revertAtbButton,
      addBtnMsg,
      hasLoyaltyAbTestFlag,
      addedTobagMsgDispatch,
      showAddtoBagDrawer,
      isOutfitCarousel,
      multipackProduct,
      currencySymbol,
      currencyAttributes,
      listPrice,
      offerPrice,
      isPlcc,
      isInternationalShipping,
      showOutfitCarouselAddedCTA,
      outfitCarouselState,
      isEnabledOutfitAddedCTA,
      closeModal,
      scrollToTarget,
      isRecommendationAvailable,
      multipackSelectionAction,
      isStyleWith,
      getDetails,
      isPhysicalMpackEnabled,
      checkForOOSForVariant,
      imageSwatchesToDisplay,
      isImageSwatchDisabled,
      setStickyFooterState,
      getRecommendationProduct,
      closePickupModal,
      initialMultipackMapping,
      setPDPLargeImage,
      largeImageNameOnHover,
      setInitialTCPStyleQty,
      resetProductDetailsDynamicData,
      setInitialQuickViewLoad,
      getQickViewSingleLoad,
      disableMultiPackTab,
      getDisableSelectedTab,
      newColorList,
      isSBP,
      childProfile,
      isSBPEnabled,
      sbpSizeClick,
      initialFormValues,
      formValues,
      isQuickView,
      isDynamicBadgeEnabled,
      onPickUpOpenClick,
      hideMultipackPills,
      disableSwappingMpackPills,
      sbpLabels,
      availableTCPmapNewStyleId,
      selectedSizeFromOutfitProduct,
      isNewReDesignProductSummary,
      userDefaultStore,
      isRadialInventoryEnabled,
      onPickupClickAddon,
      currentColorEntry,
      isNewQVEnabled,
      isNewPDPEnabled,
      socialProofMessage,
      onMultiPackChange,
      closeQuickViewSizeModal,
      isFamilyOutfitEnabled,
      isABTestPdpService,
      isPDPServiceEnabled,
      getGiftCardValue,
      isShowBrandNameEnabled,
      openModal,
      alternateBrand,
      alternateBrandFromUrl,
      alternateBrandFromState,
      isFromBundlePage,
      isSocialProofingABTestEnabled,
      selectedSizeDrawerTab,
      multiErrorOnSubmit,
      clearMultipleAddToBagError,
      addToPickupError,
      setAddToPickupError,
      isOpenAddedToBagValue,
      handleRatingClick,
      isFromChangeStore,
      accessoriesData,
      selectedAccessories,
      isShowDisabledSize,
      isSelectedSizeDisabled,
      isBopisFilterOn,
      showQuantityAddToBag,
      isBossBopisPDPSizeDrawer,
      sbpColorTheme,
      secondarySelectedAccessoryList,
      customFormFilterSize,
      tempSecondarySelectedAccessoryList,
      clearSelectedAccessories,
      allAccessories,
      getButtonBorderRadius,
      isFromPLPPage,
      isFromSLPPage,
      isPlpOrSlp,
      isPlpOrSlpDetail,
      isCustomFormPartWeb,
      isFavoritePage,
      filteredFit,
      onFitChange,
      deliveryMethodIndex,
      orderAccessoriesItems,
      route,
      selectedPickupOption,
      isNewPJPPDPRedesignEnabled,
      setPdpTabSectionName,
      isTakeDownProduct,
      isFBTEnabled,
      isCrossBrandMerchandisingEnabled,
      setUserNearStore,
      setUserDefaultStore,
      isBopisEnabled,
      isFetchClosestStore,
      storeInfoSFCCSwitch,
      openBIAShopAllDrawer,
      isShopAllDrawerOpen,
      closeBirthdayRecommandationDrawer,
      isFromBirthdayModule,
      isBopisPickupSelected,
      isHideOriginalPriceAndMarchantTagEnabled,
      nearestAvailableStore,
      fromAvailableStoresClickActn,
      isBossMultiStoreEnabled,
      isBopisMultiStoreEnabled,
      isPickUpSelectedState,
      isPickUpSelectedApp,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      isBossPickupEdit,
      defaultSuggestStore,
      isBossEditModalOpen,
      isQvPdpInfluencerHandleAbTest,
      isPlccPriceOnPDP,
      isSingleOptionEnabled,
      updateCartItemLoader,
      productInfoQV,
      isPDPRedesignEnabled,
      isPickupPromotionPDPEnabled,
      storeSpecificVariants,
      isSuppressOOSFitsEnabled,
      isShowColorSwatchLabelOnApp,
      setIsDeptClickedActn,
      isHeaderScrollViewDisabled,
      stickyATBLoaded,
      isStoreSpecialPriceEnabled,
      setMethod,
      storeSpecials,
      fromStoreDetail,
      isSocialProofOnAtbButtonEnabled,
      isStickyAtbButtonOnQvEnabled,
      isSplittingExtendedSizesEnabled,
      multiQVItemIndex,
      updateSimilarProducts,
      resetSimilarProductsActn,
      ...otherProps
    } = this.props;
    const viaModuleName = route?.params?.viaModule;
    const isViaRecommendations = viaModuleName === 'mbox_Recommendation';
    const itemValues = {
      showDefaultSizeMsg: false,
      formValues,
    };
    this.isSkuResolved = validateSkuDetails(currentProduct, itemValues);
    // RAD-74 Replace Outbound1 Inventory check to Outbound2(Radial/Boss Inventory)
    const validateBossOOS = isRadialInventoryEnabled ? isBOSSProductOOS : isProductOOS;
    const isbossInventoryAvailable = !validateBossOOS(currentProduct.colorFitsSizesMap, itemValues);
    const showPickupInfo = !userDefaultStore || !this.isSkuResolved || isbossInventoryAvailable;
    const filteredColorFitsList = colorFitsSizesMap?.filter((item) => item.maxAvailable === 0);
    const setOOSForAllVariantsFlag = (
      colorFitsSizesMapArr,
      filteredColorFitsListArr,
      isPartialOrFullVmpack
    ) => {
      let oOSForAllVariantsFlag = false;
      if (
        (colorFitsSizesMapArr && colorFitsSizesMapArr.length) ===
          (filteredColorFitsListArr && filteredColorFitsListArr.length) &&
        !isPartialOrFullVmpack
      ) {
        oOSForAllVariantsFlag = true;
      }
      return oOSForAllVariantsFlag;
    };
    const selectedColorProductInfo = getMultiPackAllColor?.find(
      (colorProduct) => colorProduct?.name === this.selectedColorHolder?.name
    );
    const selectedDepartmentSwatch = this.initialValuesFormHolder?.DepartmentSwatch;
    const isVMPEnabled = selectedColorProductInfo?.isVMPEnabled;
    const checkForOOSForAllVariantsFlag = setOOSForAllVariantsFlag(
      colorFitsSizesMap,
      filteredColorFitsList,
      tcpMultiPackReferenceUSStore && multiPackUSStore && isVMPEnabled === 'true'
    );
    const {
      selectedColor,
      selectedFit,
      selectedSize,
      fitChanged,
      isErrorMessageDisplayed,
      isATBErrorMessageDisplayed,
      selectedQuantity,
      keepAlive,
      isAccessoryMessageDisplayed,
      isVMPBossEligible,
      isBopisSelected,
      selectedProductColorIndex,
    } = this.state;
    const initalSelectedColor = this.getInitalValue(
      isQuickView,
      formValues,
      initialFormValues,
      selectedColor,
      isMultiItemQVModal
    );
    const productColorFitsSizesMap = this.shouldSuppressOOSFits()
      ? this.getColorFitsSizesMapWithoutOOSFits()
      : colorFitsSizesMap || favColorFitsSizesMap;
    const updatedSelectedColor = { name: initalSelectedColor || '' };
    if (!isEqual(updatedSelectedColor, this.selectedColorHolder)) {
      this.selectedColorHolder = updatedSelectedColor;
    }
    const updatedColorEntry = getMapSliceForColor(colorFitsSizesMap, initalSelectedColor);
    const getNewId = this.getCurrentProductId(updatedColorEntry, selectedColorProductId);
    const initialValues =
      fromBagPage && productInfoFromBag
        ? this.initialValuesForm
        : this.getInitialValues(currentProduct, getNewId);
    const generalProductId = currentProduct && currentProduct.generalProductId;
    const primaryBrand = currentProduct && currentProduct.primaryBrand;
    const { tcpStyleType, tcpStyleQty } = updatedColorEntry?.miscInfo || {};

    const alternateBrandValue = this.getAlternateBrand(alternateBrand, alternateBrandFromState);
    const hasNewFitAttribute = this.checkForNewFitAttribute({
      colorFitsSizesMap,
      selectedColor,
    });

    return (
      <ProductAddToBag
        {...otherProps}
        clearMultipleAddToBagError={clearMultipleAddToBagError}
        isPickup={isPickup}
        colorList={colorFitsSizesMap || favColorFitsSizesMap}
        fitList={
          hasNewFitAttribute && isSplittingExtendedSizesEnabled
            ? this.getNewFitOptions(productColorFitsSizesMap, selectedColor, updatedSelectedColor)
                ?.newSelectedProductFitList
            : this.getFitOptions(productColorFitsSizesMap, selectedColor, updatedSelectedColor)
        }
        sizeList={this.getSizeList(productColorFitsSizesMap, updatedSelectedColor)}
        selectSize={this.sizeChange}
        selectFit={this.fitChange}
        selectColor={this.colorChange}
        selectedColor={this.selectedColorHolder}
        isSkuResolved={this.isSkuResolved}
        showPickupInfo={showPickupInfo}
        selectedFit={selectedFit}
        selectedSize={selectedSize}
        quantityList={this.getQuantityList()}
        fitChanged={fitChanged}
        isErrorMessageDisplayed={isErrorMessageDisplayed}
        isATBErrorMessageDisplayed={isATBErrorMessageDisplayed}
        initialValues={initialValues}
        displayErrorMessage={this.displayErrorMessage}
        displayATBErrorMessage={this.displayATBErrorMessage}
        selectedQuantity={selectedQuantity}
        onQuantityChange={this.quantityChange}
        generalProductId={generalProductId}
        handleFormSubmit={handleFormSubmit}
        errorOnHandleSubmit={errorOnHandleSubmit}
        multiErrorOnSubmit={multiErrorOnSubmit}
        currentProduct={currentProduct}
        selectedColorProductId={this.getSelectedColorId(selectedColorProductId, getNewId)}
        customFormName={customFormName}
        showAddToBagCTA={showAddToBagCTA}
        showColorChips={showColorChips}
        fromBagPage={fromBagPage}
        inheritedStyles={customSubmitButtonStyle}
        colorFitSizeDisplayNames={colorFitSizeDisplayNames}
        isGiftCard={isGiftCard}
        isOutfitPage={isOutfitPage}
        isFromBundlePage={isFromBundlePage}
        ref={formRef}
        formEnabled={formEnabled}
        quickViewColorSwatchesCss={quickViewColorSwatchesCss}
        isPDP={isPDP}
        isDisableZeroInventoryEntries={isDisableZeroInventoryEntries}
        alternateSizes={alternateSizes}
        sizeChartLinkVisibility={sizeChartLinkVisibility}
        navigation={navigation}
        onCloseClick={onCloseClick}
        isBundleProduct={isBundleProduct}
        keepAlive={isKeepAliveEnabled && keepAlive}
        keepAliveFlag={keepAlive}
        isFavoriteEdit={isFavoriteEdit}
        sizeChartDetails={sizeChartDetails}
        isMultiItemQVModal={isMultiItemQVModal}
        quickViewPickup={this.quickViewPickup}
        pageNameProp={pageNameProp}
        pageSectionProp={pageSectionProp}
        pageSubSectionProp={pageSubSectionProp}
        imagesByColor={imagesByColor}
        itemBrand={itemBrand}
        relatedSwatchImages={relatedSwatchImages}
        pageAddType={this.getAddType(isOutfitPage, isPDP, isBundleProduct)}
        showAddedToBagCta={showAddedToBagCta}
        showOutfitCarouselAddedCTA={showOutfitCarouselAddedCTA}
        revertAtbButton={revertAtbButton}
        addBtnMsg={addBtnMsg}
        hasLoyaltyAbTestFlag={hasLoyaltyAbTestFlag}
        addedTobagMsgDispatch={addedTobagMsgDispatch}
        showAddtoBagDrawer={showAddtoBagDrawer}
        isOutfitCarousel={isOutfitCarousel}
        multipackProduct={multipackProduct}
        currencySymbol={currencySymbol}
        currencyAttributes={currencyAttributes}
        listPrice={listPrice}
        offerPrice={offerPrice}
        isCanada={isCanada()}
        outfitCarouselState={outfitCarouselState}
        isPlcc={isPlcc}
        isInternationalShipping={isInternationalShipping}
        isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
        closeModal={closeModal}
        scrollToTarget={scrollToTarget}
        checkForOOSForVariant={checkForOOSForAllVariantsFlag}
        isRecommendationAvailable={isRecommendationAvailable}
        TCPMultipackProductMapping={TCPMultipackProductMapping}
        TCPStyleType={tcpStyleType || TCPStyleType}
        TCPStyleQTY={tcpStyleQty || TCPStyleQTY}
        setSelectedMultipack={multipackSelectionAction}
        isStyleWith={isStyleWith}
        getDetails={getDetails}
        isPhysicalMpackEnabled={isPhysicalMpackEnabled}
        imageSwatchesToDisplay={imageSwatchesToDisplay}
        isImageSwatchDisabled={isImageSwatchDisabled}
        setStickyFooterState={setStickyFooterState}
        closePickupModal={closePickupModal}
        initialMultipackMapping={initialMultipackMapping}
        selectColorToHover={this.PDPlargeImageChangeOnHover}
        selectColorToHoverOut={this.PDPlargeImageResetOnHoverOut}
        setInitialTCPStyleQty={setInitialTCPStyleQty}
        resetProductDetailsDynamicData={resetProductDetailsDynamicData}
        setInitialQuickViewLoad={setInitialQuickViewLoad}
        getQickViewSingleLoad={getQickViewSingleLoad}
        disableMultiPackTab={disableMultiPackTab}
        getDisableSelectedTab={getDisableSelectedTab}
        newColorList={newColorList}
        formValues={formValues}
        childProfile={childProfile}
        isSBP={isSBP}
        isNewReDesignProductSummary={isNewReDesignProductSummary}
        isSBPEnabled={isSBPEnabled}
        sbpSizeClick={sbpSizeClick}
        isDynamicBadgeEnabled={isDynamicBadgeEnabled}
        onPickUpOpenClick={this.pickupModalOpenHandler}
        hideMultipackPills={hideMultipackPills}
        disableSwappingMpackPills={disableSwappingMpackPills}
        sbpLabels={sbpLabels}
        productInfoFromBag={productInfoFromBag}
        availableTCPmapNewStyleId={availableTCPmapNewStyleId}
        userDefaultStore={userDefaultStore}
        currentColorEntry={currentColorEntry}
        isNewQVEnabled={isNewQVEnabled}
        isNewPDPEnabled={isNewPDPEnabled}
        socialProofMessage={socialProofMessage}
        onMultiPackChange={onMultiPackChange}
        fromPage={this.getFromPageVal()}
        closeQuickViewSizeModal={closeQuickViewSizeModal}
        isFamilyOutfitEnabled={isFamilyOutfitEnabled}
        primaryBrand={primaryBrand}
        getGiftCardValue={getGiftCardValue}
        isShowBrandNameEnabled={isShowBrandNameEnabled}
        openModal={openModal}
        alternateBrandFromUrl={!isViaRecommendations && alternateBrandFromUrl}
        alternateBrand={!isViaRecommendations && alternateBrandValue}
        setIsBopisSelected={this.setIsBopisSelected}
        setIsSTHSelected={this.setIsSTHSelected}
        setIsBossSelected={this.setIsBossSelected}
        isBopisSelected={isBopisSelected}
        isFromChangeStore={isFromChangeStore}
        selectedSizeDrawerTab={selectedSizeDrawerTab}
        addToPickupError={addToPickupError}
        isOpenAddedToBag={isOpenAddedToBagValue}
        setAddToPickupError={setAddToPickupError}
        accessoriesData={accessoriesData}
        selectedAccessories={selectedAccessories}
        isShowDisabledSize={isShowDisabledSize}
        isSelectedSizeDisabled={isSelectedSizeDisabled}
        handleRatingClick={handleRatingClick}
        isBopisFilterOn={isBopisFilterOn}
        showQuantityAddToBag={showQuantityAddToBag}
        isBossBopisPDPSizeDrawer={isBossBopisPDPSizeDrawer}
        isQuickView={isQuickView}
        isAccessoryMessageDisplayed={isAccessoryMessageDisplayed}
        displayAccessoriesErrorMessage={this.displayAccessoriesErrorMessage}
        sbpColorTheme={sbpColorTheme}
        secondarySelectedAccessoryList={secondarySelectedAccessoryList}
        tempSecondarySelectedAccessoryList={tempSecondarySelectedAccessoryList}
        clearSelectedAccessories={clearSelectedAccessories}
        allAccessories={allAccessories}
        key={''}
        getButtonBorderRadius={getButtonBorderRadius}
        isFavoritePage={isFavoritePage}
        orderAccessoriesItems={orderAccessoriesItems}
        fromCollectionPage={fromCollectionPage}
        deliveryMethodIndex={deliveryMethodIndex}
        isVMPBossEligible={isVMPBossEligible}
        route={route}
        selectedPickupOption={selectedPickupOption}
        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
        setPdpTabSectionName={setPdpTabSectionName}
        isTakeDownProduct={isTakeDownProduct}
        isFBTEnabled={isFBTEnabled}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        getSelectedColorData={this.getSelectedColorData}
        setUserNearStore={setUserNearStore}
        setUserDefaultStore={setUserDefaultStore}
        isFetchClosestStore={isFetchClosestStore}
        storeInfoSFCCSwitch={storeInfoSFCCSwitch}
        resetSize={this.resetSize}
        resetBopisSize={this.resetBopisSize}
        resetSTHSize={this.resetSTHSize}
        isBossSelected={this.state.isBossSelected}
        isBopisEnabled={isBopisEnabled}
        setSizeAvailable={this.setSizeAvailable}
        openBIAShopAllDrawer={openBIAShopAllDrawer}
        isShopAllDrawerOpen={isShopAllDrawerOpen}
        closeBirthdayRecommandationDrawer={closeBirthdayRecommandationDrawer}
        isFromBirthdayModule={isFromBirthdayModule}
        isBopisPickupSelected={isBopisPickupSelected}
        isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
        nearestAvailableStore={nearestAvailableStore}
        fromAvailableStoresClick={fromAvailableStoresClickActn}
        isBopisMultiStoreEnabled={isBopisMultiStoreEnabled}
        isBossMultiStoreEnabled={isBossMultiStoreEnabled}
        isPickUpSelectedState={isPickUpSelectedState}
        isPickUpSelectedApp={isPickUpSelectedApp}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        isBossPickupEdit={isBossPickupEdit}
        defaultSuggestStore={defaultSuggestStore}
        isBossEditModalOpen={isBossEditModalOpen}
        isQvPdpInfluencerHandleAbTest={isQvPdpInfluencerHandleAbTest}
        selectedProductColorIndex={selectedProductColorIndex}
        isPlccPriceOnPDP={isPlccPriceOnPDP}
        isSingleOptionEnabled={isSingleOptionEnabled}
        selectedDepartmentSwatch={selectedDepartmentSwatch}
        updateCartItemLoader={updateCartItemLoader}
        productInfoQV={productInfoQV}
        isPDPRedesignEnabled={isPDPRedesignEnabled}
        isPickupPromotionPDPEnabled={isPickupPromotionPDPEnabled}
        storeSpecificVariants={storeSpecificVariants}
        isShowColorSwatchLabelOnApp={isShowColorSwatchLabelOnApp}
        setIsDeptClickedActn={setIsDeptClickedActn}
        updatePickupSelectedState={this.updatePickupSelectedState}
        isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
        stickyATBLoaded={stickyATBLoaded}
        isStoreSpecialPriceEnabled={isStoreSpecialPriceEnabled}
        setMethod={setMethod}
        storeSpecials={storeSpecials}
        fromStoreDetail={fromStoreDetail}
        isSocialProofOnAtbButtonEnabled={isSocialProofOnAtbButtonEnabled}
        isStickyAtbButtonOnQvEnabled={isStickyAtbButtonOnQvEnabled}
        isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
        checkForNewFits={this.checkForNewFits}
        getFitProductId={this.getFitProductId}
        onNewFitClick={this.onNewFitClick}
        onUpdateFit={this.onUpdateFit}
        multiQVItemIndex={multiQVItemIndex}
        updateSimilarProducts={updateSimilarProducts}
        resetSimilarProductsActn={resetSimilarProductsActn}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { pageData } = state;
  const {
    setInitialTCPStyleQty,
    previousSearchPage,
    currentProduct,
    isPDP,
    isQuickView,
    fromBagPage,
    isPickup,
    TCPStyleQTY,
  } = ownProps;
  let { getAllNewMultiPack, multipackProduct } = ownProps;
  const userDefaultStore = PickupSelectors.getDefaultStore(state);
  const geoDefaultStore = PickupSelectors.getGeoDefaultStore(state);
  const defaultStore =
    userStoreFromStorage(userDefaultStore) || userDefaultStore || geoDefaultStore || null;
  const isSearchPage = isClient() && window?.location?.href.includes('/search/');
  const isPLP = isClient() && window?.location?.href?.includes(SLASH_C_ROUTE);
  const getIsBopisFilterOnPlpSlp = (
    prevSearchPage,
    isPlpPage,
    isSearch,
    getIsBopisFilterPlp,
    getIsBopisFilterSlp
  ) => {
    const prevSearchPageBoolean = parseBoolean(prevSearchPage);
    const plpCheck = !isSearch && (!prevSearchPageBoolean || isPlpPage);
    const searchCheck = !isPlpPage && (prevSearchPageBoolean || isSearch);
    return (
      (plpCheck && getIsBopisFilterPlp) ||
      (searchCheck && getIsBopisFilterSlp) ||
      isShopThisStoreModeOn()
    );
  };

  if (TCPStyleQTY !== '1' && (!multipackProduct || !getAllNewMultiPack)) {
    const isFromQVModal = isQuickView || fromBagPage;
    if (isPickup) {
      multipackProduct = getMultipackProductPickup(state);
      getAllNewMultiPack = getAllNewMultiPackPickup(state);
    } else {
      multipackProduct = isFromQVModal
        ? getMultipackProductQV(state)
        : getMultiPackProductInfo(state);
      getAllNewMultiPack = isFromQVModal
        ? getAllNewMultiPackQV(state)
        : getAllNewMultiPackData(state);
    }
  }
  const isRecommendationsQV = PickupSelectors.getFromRecommQV(state);
  return {
    userDefaultStore: defaultStore,
    pageNameProp: getPageName(state),
    pageSectionProp: getPageSection(state),
    pageSubSectionProp: getPageSubSection(state),
    pageData,
    currency: getCurrentCurrency(state),
    storeId: getUserStoreId(state),
    ledgerSummaryData: getLedgerSummaryData(state),
    unbxdId: getUnbxdId(state),
    hideStickyABTest: getStickyATCABTest(state),
    showAddtoBagDrawer: getABTestAddToBagDrawer(state),
    isEnabledOutfitAddedCTA: !isCanada() && getIsOutfitAddedCTAEnabled(state),
    outfitCarouselState: getOutfitCarouselState(state),
    addBtnMsg: addedToBagMsgSelector(state),
    hasLoyaltyAbTestFlag: loyaltyAbTestFlagSelector(state),
    showAddedToBagCta: getShowAddedToBagCTA(state),
    showOutfitCarouselAddedCTA: getOutfitCarouselAddedCTA(state),
    selectedMultipack: getSelectedMultipack(state),
    isPhysicalMpackEnabled: getIsPhysicalMpackEnabled(state),
    isImageSwatchDisabled: isPDP ? getIsImageSwatchDisabled(state) : true,
    isABTestLoaded: getIsABLoaded(state),
    getRecommendationProduct: getProducts(state, 'pdp'),
    largeImageNameOnHover: getPDPlargeImageColorSelector(state),
    setInitialTCPStyleQty,
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    disableSwappingMpackPills: getABTestSwapMpackPills(state),
    selectedProducts: getSelectedProductList(state),
    cartsSessionStatus: getCartsSessionStatus(state),
    isRadialInventoryEnabled: getIsRadialInventoryEnabled(state),
    fromPage: getFromPage(state),
    isPDPServiceEnabled: getIsPdpServiceEnabled(state),
    isABTestPdpService: getABTestPdpService(state),
    alternateBrandFromState: getAlternateBrandName(state),
    isPlcc: isPlccUser(state),
    bopisItemInventory: isRecommendationsQV
      ? PickupSelectors.getRecommendationsBopisItemInventory(state)
      : PickupSelectors.getBopisItemInventory(state),
    breadCrumbs: getBreadCrumbs(state),
    addToPickupError: getAddedToPickupError(state),
    isOpenAddedToBagValue: isOpenAddedToBag(state),
    selectedAccessories: getSelectedAccessories(state),
    isSelectedSizeDisabled: getSelectedSizeDisabled(state),
    isBopisFilterOn: getIsBopisFilterOnPlpSlp(
      previousSearchPage,
      isPLP,
      isSearchPage,
      getIsBopisFilterOn(state),
      getIsBopisFilterOnSlp(state)
    ),
    accessoriesDataQV: getProductInfo(state),
    isAccessoriesEnabled: getIsAccessoryEnabled(state),
    isStickyAtbHeader: getIsStickyAtbHeader(state),
    secondarySelectedAccessoryList: getSecondarySelectedAccessories(state),
    firstTouchBannerFromHP: getFirstTimeCaptureBanner(state),
    firstTouchShopMenu: getFirstTimeCaptureShopMenu(state),
    tempSecondarySelectedAccessoryList: getTempSelectedSecondaryAccessories(state),
    allAccessories: getAccessories(state),
    grandParentId: getGrandParentId(state),
    currentHighlightedIndex: getCurrentHighlightedIndex(state),
    accessoriesData: getAccessoriesData(state, isSearchPage, isPLP, currentProduct),
    secondaryAccessories: getSecondaryAccessories(state),
    grandParentSize: getGrandParentSize(state),
    sizeDeselect: getDeselectSize(state),
    isFavoritePage: getFavoritePage(state),
    grandParentScreen: getGrandParentScreen(state),
    grandParentFit: getGrandParentFit(state),
    grandParentColor: getGrandParentColor(state),
    getGrandParentQty: getGrandParentQuantity(state),
    deliveryMethodIndex: getDeliveryMethodIndex(state),
    parentCustomizationType: getParentCustomizationType(state),
    isVMPBOSSEnabled: getIsVMPBossEnabled(state),
    productInfoFromBag: getProductInfoFromBag(state),
    orderAccessoriesItems: BagPageSelectors.getorderAccessorieItems(state),
    multiPackThreshold: getMultiPackThreshold(state),
    selectedPickupOption: getSelectedPickupOption(state),
    multipackProduct,
    getAllNewMultiPack,
    isNewPJPPDPRedesignEnabled: getIsNewPJPPDPRedesignEnabled(state),
    isTakeDownProduct: getIsTakeDownProduct(state),
    isFBTEnabled: getIsFBTShowEnabled(state),
    itemsWithEDD: getItemsWithEDD(state),
    orderEddDates: getOrderEddDates(state),
    isShowShipToHomeEddEnabled: getIsShowShipToHomeEddEnabled(state),
    isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
    isPDPInventoryCheckEnabled: getIsPDPInventoryCheckEnabled(state),
    isUserPersonalizationEnabled: getIsUserPersonalizationEnabled(state),
    isUserPersonalizationRefreshTime: getUserPersonalizationRefreshTime(state),
    isUserLoggedIn: getUserLoggedInState(state),
    isBopisEnabled: getIsBopisEnabled(state),
    isFetchClosestStore: getFetchClosestStore(state),
    storeInfoSFCCSwitch: getSwitchToSfccForStoreInfo(state),
    isPickupModalOpen: getIsPickupModalOpen(state),
    isShopAllDrawerOpen: getIsShopAllDrawerOpen(state),
    isFromBirthdayModule: getIsFromBirthdayModule(state),
    isBopisPickupSelected: getIsBopisPickupSelected(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    nearestAvailableStore: getNearestAvailableStore(state),
    isBopisMultiStoreEnabled: getBopisMultipleStoreEnabled(state),
    isBossMultiStoreEnabled: getBossMultipleStoreEnabled(state),
    isPickUpSelectedState: getIsPickUpSelected(state),
    isHardcodeSizeMapEnabled: getIsHardcodeSizeMapEnabled(state),
    hardcodeSizeMapConfig: getHardcodeSizeMapConfig(state),
    defaultSuggestStore: getDefaultSuggestedStore(state),
    isBossEditModalOpen: getIsBossEditModalOpen(state),
    isQvPdpInfluencerHandleAbTest: getisQvPdpInfluencerHandleAbTest(state),
    isPlccPriceOnPDP: getIsPlccPriceOnPDP(state),
    isSingleOptionEnabled: getIsSingleOptionEnabled(state),
    outfitV3WidgetVDABTestEnabled: getOutfitV3WidgetVDABTest(state),
    outfitV3WidgetMnMABTest: getOutfitV3WidgetMnMABTest(state),
    outfitV3WidgetEnabled: getOutfitV3Widget(state),
    disableAlsoAvailablePills: getIsAlsoAvailablePillsDisabled(state),
    alternateStyles: getAlternateStyles(state),
    updateCartItemLoader: getUpdateCartItemLoader(state),
    isShowPriceRangeKillSwitch: getIsShowPriceRange(state),
    showPriceRangeForABTest: getABTestIsShowPriceRange(state),
    isPickupPromotionPDPEnabled: getIsPickupPromotionPDPEnabled(state),
    storeSpecificVariants: PickupSelectors.getStoreSpecificVariants(state),
    isSuppressOOSFitsEnabled: getIsSuppressOOSFitsEnabled(state),
    isShowColorSwatchLabelOnApp: getShowColorSwatchLabelOnApp(state),
    isHeaderScrollViewDisabled: getIsHeaderScrollViewDisabled(state),
    isShowDeleteIconInBag: getIsShowDeleteIconInBag(state),
    addedToBagBtnLoader: getAdddToBagBtnLoader(state),
    addedToBagError: getAddedToBagError(state),
    isSupressAtbModalOnBag: getIsSupressATBModalOnBag(state),
    isStoreSpecialPriceEnabled: getShowBopisTileBasedOnStoreSpecials(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
    sfccSocialProofingOn: getSfccSocialProofingEnabled(state),
    sfccSocialProofingThreshold: getSfccSocialProofingThreshold(state),
    isBopisMultipleStoreEnabled: getBopisMultipleStoreEnabled(state),
    storeIdList: getStoresIDList(state),
    mapboxStoreSearchTypesParam: getStoreSearchTypesParam(state),
    isAppendUPCInPDPURLEnabled: getIsAppendUPCInPDPURLEnabled(state),
    shouldAllowOnlineProductPickup: allowOnlineProductPickup(state),
    isSocialProofOnAtbButtonEnabled: getIsSocialProofOnATBButtonEnabled(state),
    isStickyAtbButtonOnQvEnabled: getIsStickyAtbButtonOnQvEnabled(state),
    isSplittingExtendedSizesEnabled: getIsSplittingExtendedSizesEnabled(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setAnalyticsData: (payload) => {
      dispatch(setClickAnalyticsData(payload));
    },
    onPickUpOpenClick: (payload) => {
      if (payload.fromPills) {
        dispatch(setPickupModal(payload));
      } else {
        dispatch(openPickupModalWithValues(payload));
      }
    },
    closeQuickViewSizeModal: () => {
      dispatch(closeQuickViewModal({ isModalOpen: false }));
    },
    addedTobagMsgDispatch: (payload) => {
      dispatch(addedTobagMsg(payload));
    },
    outfitCarouselAddedToBagMsgDispatch: (payload) => {
      dispatch(setOutfitCarouselAddedButton(payload));
    },
    quantityChange: (payload) => {
      dispatch(change(payload.form, 'Quantity', payload.selectedQuantity));
    },
    sizeChange: (payload) => {
      dispatch(change(payload.form, 'Size', payload.size));
    },
    revertAtbButton: () => {
      const addBagTimer = setTimeout(() => {
        dispatch(setAddedToBagButton(''));
        clearTimeout(addBagTimer);
      }, 2000);
    },
    revertCarouselAtbButton: () => {
      const carouselAddTimer = setTimeout(() => {
        dispatch(setOutfitCarouselAddedButton(false));
        clearTimeout(carouselAddTimer);
      }, 2000);
    },
    multipackSelectionAction: (payload) => {
      dispatch(updateMultipackSelection(payload));
    },
    setStickyFooterState: (payload) => {
      dispatch(setStickyFooter(payload));
    },
    setPDPLargeImage: (payload) => {
      dispatch(setPDPLargeImageURL(payload));
    },
    addItemToCartInPickup: (payload) => {
      dispatch(addItemToCartBopis(payload));
    },
    setAddToPickupError: (payload) => {
      dispatch(AddToPickupError(payload));
    },
    trackClickDispatch: (payload) => dispatch(trackClick(payload)),
    trackAnalyticsClick: (payload, eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    clearMultipleAddToBagError: () => {
      dispatch(clearAddToCartMultipleItemErrorState());
    },
    updateSize: (payload) => {
      dispatch(change(payload.form, 'Size', payload.size));
      dispatch(setIsSkuEditFlag({ isSkuSelected: true }));
    },
    updateColor: (payload) => {
      dispatch(change(payload.form, 'color', payload.color));
    },
    updateFit: (payload) => {
      dispatch(change(payload.form, 'Fit', payload.fit));
    },
    updateSizeStatus: (payload) => {
      dispatch(updateSelectedSizeStatus(payload));
    },
    autoIncrementAccessaryOnQuantityChange: (payload) => {
      dispatch(autoIncrementAccessary(payload));
    },
    parentProductQtyChange: (payload) => {
      dispatch(storeParentProductQty(payload));
    },
    removeSecondaryAccessoryFromState: (payload) => {
      dispatch(removeSecondaryAccessory(payload));
    },
    clearSelectedAccessories: () => {
      dispatch(clearAllSelectedAccessories());
    },
    clearSecondaryAccessoryDetails: () => {
      dispatch(resetSecondaryAccessoryDetails());
    },
    accessorySizeError: (payload) => {
      dispatch(accessorySizeErrorAction(payload));
    },
    saveAccessoryGrandParentSize: (payload) => {
      dispatch(saveAccessoryGrandParentSizeAction(payload));
    },
    deselectSize: (payload) => {
      dispatch(deselectSizeAction(payload));
    },
    saveAccessoryGrandParentColor: (payload) => {
      dispatch(saveAccessoryGrandParentColorAction(payload));
    },
    saveAccessoryGrandParentFit: (payload) => {
      dispatch(saveAccessoryGrandParentFitAction(payload));
    },
    saveAccessoryGrandParentQty: (payload) => {
      dispatch(saveAccessoryGrandParentQuantityAction(payload));
    },
    setProductDataForReviewActn: (payload) => dispatch(setProductDataForReview(payload)),
    setPdpTabSectionName: (payload) => {
      dispatch(setTabSectionName(payload));
    },
    setUserNearStore: (payload) => {
      dispatch(setUserNearStoreData(payload));
    },
    setUserDefaultStore: (payload) => {
      dispatch(setDefaultStore(payload));
    },
    setSizeSelectAvailable: (payload) => {
      dispatch(selectSizeMsgShow(payload));
    },
    openBIAShopAllDrawer: (payload) => dispatch(openShopAllDrawer(payload)),
    closeBirthdayRecommandationDrawer: (payload) => {
      dispatch(OpenBirthdayRecommandationDrawer(payload));
    },
    fromAvailableStoresClickActn: (payload) => {
      dispatch(fromAvailableStoresClick(payload));
    },
    setAlternateStylesAct: (payload) => {
      dispatch(setAlternateStyles(payload));
    },
    setIsDeptClickedActn: (payload) => {
      dispatch(setIsDeptClicked(payload));
    },
    setStyliticsProductTabListData: (payload) => {
      dispatch(styliticsProductTabListDataSuccess(payload));
    },
    setSelectedProductIdForOutfit: (payload) => dispatch(setSelectedProductId(payload)),
    setDataForPDP: (payload) => dispatch(saveQVDataForPDP(payload)),
    removeCartItem: (orderItemId) => {
      dispatch(removeCartItem(orderItemId));
    },
    setCartItemsSflError: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setCartItemsSflError(payload));
    },
    clearCheckoutServerError: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(data)),
    stickyATBLoaded: (payload) => dispatch(isStickyATBLoaded(payload)),
    getBopisStores: (payload) => {
      dispatch(getBopisStoresActn(payload));
    },
    getSelectedFitProductActn: (payload) => dispatch(getSelectedFitProduct(payload)),
    getSelectedOutfitFitProductActn: (payload) => dispatch(getSelectedOutfitFitProduct(payload)),
    getDataOnNewFitsClickActn: (payload) => dispatch(getDataOnNewFitsClick(payload)),
  };
}

ProductAddToBagContainer.propTypes = {
  showAddToBagCTA: PropTypes.bool.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  currentProduct: PropTypes.shape({}).isRequired,
  selectedColorProductId: PropTypes.number.isRequired,
  toastMessage: PropTypes.func.isRequired,
  clearAddToBagError: PropTypes.func,
  clearMultipleAddToBagError: PropTypes.func,
  isBundleProduct: PropTypes.bool.isRequired,
  isFromBagProductSfl: PropTypes.bool.isRequired,
  isFavoriteEdit: PropTypes.bool.isRequired,
  sizeChartDetails: PropTypes.shape([]).isRequired,
  fromBagPage: PropTypes.bool.isRequired,
  keepAlive: PropTypes.bool.isRequired,
  isOutfitPage: PropTypes.bool.isRequired.isRequired,
  showColorChips: PropTypes.bool.isRequired.isRequired,
  quickViewColorSwatchesCss: PropTypes.string.isRequired,
  isPDP: PropTypes.bool.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  isPlcc: PropTypes.bool.isRequired,
  currencyAttributes: PropTypes.shape({}).isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  listPrice: PropTypes.string.isRequired,
  offerPrice: PropTypes.string.isRequired,
  itemBrand: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func,
  isPickup: PropTypes.bool.isRequired,
  sizeChartLinkVisibility: PropTypes.number.isRequired,
  selectSize: PropTypes.func.isRequired,
  isDisableZeroInventoryEntries: PropTypes.bool.isRequired,
  showAddedToBagCta: PropTypes.bool.isRequired,
  revertAtbButton: PropTypes.func.isRequired,
  alternateSizes: PropTypes.shape([]).isRequired,
  errorOnHandleSubmit: PropTypes.func.isRequired,
  multiErrorOnSubmit: PropTypes.string,
  navigation: PropTypes.shape({}).isRequired,
  productInfoFromBag: PropTypes.shape({}).isRequired,
  fromPDP: PropTypes.bool.isRequired,
  onFitChange: PropTypes.func.isRequired,
  onChangeColor: PropTypes.func.isRequired,
  onChangeSize: PropTypes.func.isRequired,
  updateQuantityChange: PropTypes.func,
  getSKUValidated: PropTypes.func.isRequired,
  quantityChange: PropTypes.func.isRequired,
  isMultiItemQVModal: PropTypes.bool.isRequired,
  customFormName: PropTypes.string.isRequired,
  customSubmitButtonStyle: PropTypes.shape({}).isRequired,
  colorFitsSizesMap: PropTypes.shape({}).isRequired,
  favColorFitsSizesMap: PropTypes.shape({}).isRequired,
  formRef: PropTypes.shape({}).isRequired,
  formEnabled: PropTypes.bool.isRequired,
  isKeepAliveEnabled: PropTypes.bool.isRequired,
  pageNameProp: PropTypes.string.isRequired,
  pageSectionProp: PropTypes.string.isRequired,
  pageSubSectionProp: PropTypes.string.isRequired,
  addedTobagMsgDispatch: PropTypes.func.isRequired,
  addBtnMsg: PropTypes.string.isRequired,
  hasLoyaltyAbTestFlag: PropTypes.bool,
  showAddtoBagDrawer: PropTypes.bool.isRequired,
  isOutfitCarousel: PropTypes.bool,
  showOutfitCarouselAddedCTA: PropTypes.bool,
  outfitCarouselState: PropTypes.bool,
  isEnabledOutfitAddedCTA: PropTypes.bool.isRequired,
  multipackProduct: PropTypes.string.isRequired,
  multiPackThreshold: PropTypes.string.isRequired,
  multiPackCount: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  getAllNewMultiPack: PropTypes.shape({}).isRequired,
  partIdInfo: PropTypes.shape({}).isRequired,
  scrollToTarget: PropTypes.func.isRequired,
  isRecommendationAvailable: PropTypes.bool.isRequired,
  multipackSelectionAction: PropTypes.func,
  isStyleWith: PropTypes.bool,
  getDetails: PropTypes.shape({}).isRequired,
  isPhysicalMpackEnabled: PropTypes.bool,
  checkForOOSForVariant: PropTypes.bool.isRequired,
  imageSwatchesToDisplay: PropTypes.shape([]).isRequired,
  isImageSwatchDisabled: PropTypes.bool,
  setStickyFooterState: PropTypes.func.isRequired,
  getRecommendationProduct: PropTypes.bool.isRequired,
  closePickupModal: PropTypes.func.isRequired,
  initialMultipackMapping: PropTypes.shape([]).isRequired,
  setPDPLargeImage: PropTypes.func,
  largeImageNameOnHover: PropTypes.string,
  setInitialTCPStyleQty: PropTypes.bool.isRequired,
  resetProductDetailsDynamicData: PropTypes.shape([]).isRequired,
  trackAnalyticsClick: PropTypes.func,
  setInitialQuickViewLoad: PropTypes.bool.isRequired,
  getQickViewSingleLoad: PropTypes.func.isRequired,
  disableMultiPackTab: PropTypes.bool.isRequired,
  getDisableSelectedTab: PropTypes.func.isRequired,
  newColorList: PropTypes.shape([]),
  childProfile: PropTypes.shape({}).isRequired,
  sbpSizeClick: PropTypes.func.isRequired,
  isSBP: PropTypes.bool,
  sbpSize: PropTypes.bool,
  isSBPEnabled: PropTypes.bool,
  sbpFormValues: PropTypes.shape({}).isRequired,
  size: PropTypes.string,
  sbpFit: PropTypes.string,
  initialFormValues: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
  isQuickView: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({}).isRequired,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  onPickUpOpenClick: PropTypes.func,
  hideMultipackPills: PropTypes.bool,
  disableSwappingMpackPills: PropTypes.bool,
  sbpLabels: PropTypes.shape({}),
  availableTCPmapNewStyleId: PropTypes.shape([]),
  selectedSizeFromOutfitProduct: PropTypes.string.isRequired,
  cartsSessionStatus: PropTypes.number.isRequired,
  isNewReDesignProductSummary: PropTypes.bool,
  userDefaultStore: PropTypes.shape({
    basicInfo: PropTypes.shape({
      /** store id identifier */
      id: PropTypes.string.isRequired,
      /** store Name */
      storeName: PropTypes.string.isRequired,
    }).isRequired,
  }),
  isRadialInventoryEnabled: PropTypes.bool,
  onPickupClickAddon: PropTypes.func,
  currentColorEntry: PropTypes.shape({}),
  isNewQVEnabled: PropTypes.bool,
  isNewPDPEnabled: PropTypes.bool,
  socialProofMessage: PropTypes.string,
  onMultiPackChange: PropTypes.func,
  sizeChange: PropTypes.func,
  fromPage: PropTypes.string,
  pageName: PropTypes.string,
  closeQuickViewSizeModal: PropTypes.func,
  isFamilyOutfitEnabled: PropTypes.bool,
  isPDPServiceEnabled: PropTypes.bool,
  isABTestPdpService: PropTypes.bool,
  getGiftCardValue: PropTypes.string,
  isShowBrandNameEnabled: PropTypes.bool,
  openModal: PropTypes.func,
  isFromBundlePage: PropTypes.bool,
  isFromChangeStore: PropTypes.bool,
  selectedSizeDrawerTab: PropTypes.number,
  addToPickupError: PropTypes.string,
  isOpenAddedToBag: PropTypes.bool,
  setAddToPickupError: PropTypes.func,
  updateSizeStatus: PropTypes.func,
  isShowDisabledSize: PropTypes.bool,
  deliveryType: PropTypes.string,
  isSelectedSizeDisabled: PropTypes.bool,
  handleRatingClick: PropTypes.func,
  isBopisFilterOn: PropTypes.bool,
  isBossBopisPDPSizeDrawer: PropTypes.bool,
  isSizeSelected: PropTypes.bool,
  previousSearchPage: PropTypes.bool,
  customFormFilterSize: PropTypes.string,
  updateFilteredFit: PropTypes.func,
  filteredFit: PropTypes.string,
  appliedQVPrefilledDetails: PropTypes.bool,
  updateAppliedQVPrefilledDetails: PropTypes.func,
  isPlpOrSlp: PropTypes.bool,
  isPlpOrSlpDetail: PropTypes.bool,
  isFromPLPPage: PropTypes.bool,
  isFromSLPPage: PropTypes.bool,
  isCustomFormPartWeb: PropTypes.bool,
  isFavoritePage: PropTypes.bool,
  fromCollectionPage: PropTypes.bool,
  setProductDataForReviewActn: PropTypes.func,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  setPdpTabSectionName: PropTypes.func,
  isTakeDownProduct: PropTypes.bool,
  isFBTEnabled: PropTypes.bool,
  isPDPInventoryCheckEnabled: PropTypes.bool,
  isUserPersonalizationEnabled: PropTypes.bool,
  isUserPersonalizationRefreshTime: PropTypes.number,
  setUserNearStore: PropTypes.func,
  setUserDefaultStore: PropTypes.func,
  isHardcodeSizeMapEnabled: PropTypes.bool,
  hardcodeSizeMapConfig: PropTypes.shape({}),
  isQvPdpInfluencerHandleAbTest: PropTypes.bool,
  isBossPickupEdit: PropTypes.bool,
  isSingleOptionEnabled: PropTypes.bool,
  outfitV3WidgetVDABTestEnabled: PropTypes.bool,
  outfitV3WidgetMnMABTest: PropTypes.bool,
  updateCartItemLoader: PropTypes.bool,
  isPickupPromotionPDPEnabled: PropTypes.bool,
  isSuppressOOSFitsEnabled: PropTypes.bool,
  isHeaderScrollViewDisabled: PropTypes.bool,
  updatePickupSelectedAtProductDetail: PropTypes.func,
  shouldAllowOnlineProductPickup: PropTypes.bool,
  isAppendUPCInPDPURLEnabled: PropTypes.bool,
};

ProductAddToBagContainer.defaultProps = {
  isOutfitCarousel: false,
  showOutfitCarouselAddedCTA: false,
  outfitCarouselState: false,
  hasLoyaltyAbTestFlag: false,
  multipackSelectionAction: () => {},
  isStyleWith: false,
  isPhysicalMpackEnabled: true,
  isImageSwatchDisabled: false,
  setPDPLargeImage: () => {},
  largeImageNameOnHover: '',
  trackAnalyticsClick: () => {},
  newColorList: [],
  isSBP: false,
  sbpSize: false,
  isSBPEnabled: false,
  multiErrorOnSubmit: '',
  size: '',
  sbpFit: '',
  isDynamicBadgeEnabled: false,
  onPickUpOpenClick: () => {},
  hideMultipackPills: false,
  disableSwappingMpackPills: false,
  sbpLabels: {},
  availableTCPmapNewStyleId: [],
  isNewReDesignProductSummary: false,
  userDefaultStore: {
    basicInfo: {
      id: '',
      storeName: '',
    },
  },
  isRadialInventoryEnabled: false,
  onPickupClickAddon: () => {},
  currentColorEntry: {},
  isNewQVEnabled: false,
  isNewPDPEnabled: false,
  socialProofMessage: '',
  onMultiPackChange: () => {},
  sizeChange: () => {},
  clearAddToBagError: () => {},
  clearMultipleAddToBagError: () => {},
  fromPage: '',
  pageName: '',
  closeQuickViewSizeModal: () => {},
  isFamilyOutfitEnabled: false,
  isPDPServiceEnabled: false,
  isABTestPdpService: false,
  getGiftCardValue: '',
  isShowBrandNameEnabled: false,
  openModal: () => {},
  isFromBundlePage: false,
  isFromChangeStore: false,
  selectedSizeDrawerTab: 0,
  addToPickupError: '',
  isOpenAddedToBag: false,
  setAddToPickupError: () => {},
  onCloseClick: () => {},
  handleRatingClick: () => {},
  updateQuantityChange: () => {},
  updateSizeStatus: () => {},
  isShowDisabledSize: false,
  isSelectedSizeDisabled: false,
  isBopisFilterOn: false,
  isBossBopisPDPSizeDrawer: false,
  isSizeSelected: false,
  previousSearchPage: false,
  customFormFilterSize: '',
  updateFilteredFit: () => {},
  filteredFit: '',
  appliedQVPrefilledDetails: true,
  updateAppliedQVPrefilledDetails: () => {},
  isPlpOrSlp: false,
  isPlpOrSlpDetail: false,
  isFromPLPPage: false,
  isFromSLPPage: false,
  isCustomFormPartWeb: false,
  isFavoritePage: false,
  deliveryType: '',
  fromCollectionPage: false,
  setProductDataForReviewActn: () => {},
  isNewPJPPDPRedesignEnabled: false,
  setPdpTabSectionName: () => {},
  isTakeDownProduct: false,
  isFBTEnabled: false,
  isPDPInventoryCheckEnabled: false,
  isUserPersonalizationEnabled: false,
  isUserPersonalizationRefreshTime: 900,
  setUserNearStore: PropTypes.func,
  setUserDefaultStore: PropTypes.func,
  isHardcodeSizeMapEnabled: false,
  hardcodeSizeMapConfig: {},
  isQvPdpInfluencerHandleAbTest: false,
  isBossPickupEdit: false,
  isSingleOptionEnabled: false,
  outfitV3WidgetVDABTestEnabled: false,
  outfitV3WidgetMnMABTest: true,
  updateCartItemLoader: false,
  isPickupPromotionPDPEnabled: false,
  isSuppressOOSFitsEnabled: false,
  isHeaderScrollViewDisabled: false,
  updatePickupSelectedAtProductDetail: () => {},
  shouldAllowOnlineProductPickup: false,
  isAppendUPCInPDPURLEnabled: false,
};

/* Export container */

export default connect(mapStateToProps, mapDispatchToProps)(ProductAddToBagContainer);

export { ProductAddToBagContainer as ProductAddToBagContainerVanilla };
